import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  SelectChangeEvent,
  Checkbox,
  FormGroup,
  Switch,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Stack,
  InputAdornment
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { aiApi } from '../../services/aiApi';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// useState ve useEffect zaten yukarıda import edildi
import { useMediaQuery } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import axios from 'axios';
import axiosInstance from '../../config/axios';
import React, { useState, useEffect, ReactNode, useCallback, useRef, useMemo } from 'react';
import ReactConfetti from 'react-confetti';
import { useNavigate } from 'react-router-dom'; // useLocation kaldırıldı
import * as signalR from '@microsoft/signalr';
import { v4 as uuidv4 } from 'uuid';

import CustomerPropertiesModal from '../../components/customers/CustomerPropertiesModal';
import SubCustomersModal, { SubCustomer } from '../../components/customers/SubCustomersModal';
import { API_BASE_URL } from '../../config/constants';
import { useAuth } from '../../contexts/Auth';
import { useCurrencies } from '../../hooks/useCurrencies';
import { customerLookupApi, PriceGroup, CustomerDiscountGroup } from '../../services/customerLookupApi';
import { useCustomerProperties } from '../../hooks/useCustomerProperties';
import { useTaxOffices } from '../../hooks/useTaxOffices';
import { keyframes } from '@mui/system';
import { customerApi } from '../../services/api'; // createCustomerBasic direk import edilmeyecek
import { saveCustomerProperties } from '../../services/customerPropertiesApi';
import '../../styles/forms.css';
import { DEFAULT_CUSTOMER_PROPERTIES, resolveSalespersonByRegion, DEFAULT_PRICE_GROUP_CODE, DEFAULT_DISCOUNT_GROUP_CODE } from '../../services/customerPropertiesDefaults';
import { validateTCNumber, validateTaxNumber } from '../../utils/validationUtils';
import { extractCustomerFromImage, OcrExtractResult } from '../../services/ocrApi';
import settingsApi from '../../services/settingsApi';
import { customerService } from '../../services/customerService';

// Tarama (scanline) animasyonu - JSX icinden kullanilabilmesi icin module scope'ta
const scanAnim = keyframes`
  0% { transform: translateY(-100%); opacity: 0.0; }
  10% { opacity: 0.25; }
  50% { opacity: 0.6; }
  90% { opacity: 0.25; }
  100% { transform: translateY(100%); opacity: 0.0; }
`;

// Alternatif hareket eden yatay çizgi animasyonu ve yanıp sönen metin
const scanMove = keyframes`
  0%, 100% { transform: translateY(190px); }
  50% { transform: translateY(0%); }
  75% { transform: translateY(160px); }
`;

const blinkAnim = keyframes`
  50% { opacity: 0; }
`;

// Yeni efektler: dikey tarama çubuğu ve nokta animasyonu
const animationBar = keyframes`
  0%, 100% { top: 0%; }
  50% { top: 100%; }
`;

const animationDot = keyframes`
  0%, 100% { width: 0; }
  50% { width: 120px; }
`;

// Müşteri oluşturma formu
const CustomerCreate = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login, user } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Request bazlı SignalR eşleşmesi için benzersiz ID
  const [requestId] = useState<string>(() => uuidv4());
  const [hubConnection, setHubConnection] = useState<signalR.HubConnection | null>(null);
  const isDev = process.env.NODE_ENV === 'development';
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isOcrLoading, setIsOcrLoading] = useState(false);
  const [ocrImageUrl, setOcrImageUrl] = useState<string | null>(null);
  // OCR önizleme modalı için state
  const [ocrPreview, setOcrPreview] = useState<OcrExtractResult | null>(null);
  // OCR düzenleme state'i: kullanıcı modal içinde alanları güncelleyebilir
  const [ocrEdit, setOcrEdit] = useState<OcrExtractResult | null>(null);
  // OCR modalı için seçilen Vergi Dairesi Kodu
  const [ocrTaxOfficeCode, setOcrTaxOfficeCode] = useState<string>('');
  const [ocrModalOpen, setOcrModalOpen] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    formType: 'detailed',
    customerType: '3',
    isIndividual: false, // Detaylı giriş için varsayılan olarak tüzel kişi
    country: 'TR',
    region: '',
    city: '',
    district: '',
    taxOffice: '', // Tutarlılık için taxOffice kullanıyoruz
    taxNumber: '',
    identityNum: '',
    firstName: '',
    lastName: '',
    customerName: '', // Boş başlat, placeholder olarak gösterilecek

    address: '',
    authPhone: '', // Yetkili Kişi Telefonu
    accountingPhone: '', // Muhasebe Telefonu
    authEmail: '', // Yetkili Kişi E-posta
    accountingEmail: '', // Muhasebe E-posta
    contactName: '',
    isSubjectToEInvoice: false,
    eInvoiceStartDate: null as Date | null,
    isSubjectToEDispatch: false,
    eDispatchStartDate: null as Date | null,
    exchangeTypeCode: 'TRY', // Para birimi varsayılan değeri
    // Teslimat adresi kontrolü ve alanları
    isShippingSameAsBilling: true,
    shippingRegion: '',
    shippingCity: '',
    shippingDistrict: '',
    shippingAddress: '',
  });
  
  // Müşteri özellikleri modalı için state
  const [isCustomerPropertiesModalOpen, setIsCustomerPropertiesModalOpen] = useState(false);
  // Alt müşteriler (prSubCurrAcc) için state ve modal
  const [subCustomers, setSubCustomers] = useState<SubCustomer[]>([]);
  const [isSubCustomersModalOpen, setIsSubCustomersModalOpen] = useState(false);
  // Aynı bölge için modalın tekrar tekrar otomatik açılmasını engellemek için ref
  const lastAutoOpenRegionRef = useRef<string>('');
  // Lookup seçimleri: Toptan Fiyat ve İskonto Grubu
  // Lookup seçimleri: Modal'dan gelen değerleri taşıyacağız; sayfa içinde hardcode etmeyelim
  const [selectedWholesalePriceGroupCode, setSelectedWholesalePriceGroupCode] = useState<string>('');
  const [selectedDiscountGroupCode, setSelectedDiscountGroupCode] = useState<string>('');
  const { propertyTypes, propertyValues, loading, error, loadProperties, saveProperties } = useCustomerProperties();
  // Seçilen müşteri özelliklerini saklamak için state
  const [selectedCustomerProperties, setSelectedCustomerProperties] = useState<Record<number, string>>({});
  // Per-DB seçimleri (ST DERİ ve SERKAN ÇANTA için ayrı)
  const [perDbSelections, setPerDbSelections] = useState<{
    stDeri: { priceGroup: string; discountGroup: string; invoiceType: string; salesperson?: string };
    serkanCanta: { priceGroup: string; discountGroup: string; invoiceType: string; salesperson?: string };
  }>({
    stDeri: { priceGroup: '', discountGroup: '', invoiceType: '', salesperson: '' },
    serkanCanta: { priceGroup: '', discountGroup: '', invoiceType: '', salesperson: '' }
  });

  // Referans veri state'leri
  const [countries, setCountries] = useState<any[]>([]);
  const [types, setTypes] = useState<any[]>([]);
  const [regions, setRegions] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [districts, setDistricts] = useState<any[]>([]);
  // TC Kimlik doğruluğu (useMemo)
  const isValidIdentityNum = useMemo(() => {
    const v = formData.identityNum || '';
    if (!/^\d{11}$/.test(v)) return false;
    try { return validateTCNumber(v); } catch { return false; }
  }, [formData.identityNum]);
  // Teslimat adresi için şehir/ilçe listeleri
  const [shippingCities, setShippingCities] = useState<any[]>([]);
  const [shippingDistricts, setShippingDistricts] = useState<any[]>([]);
  const [locationHierarchy, setLocationHierarchy] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' });
  // Mükerrer kontrolü uyarı state'i
  const [dupeResults, setDupeResults] = useState<any[]>([]);
  const [dupeOpen, setDupeOpen] = useState(false);
  // Çoklu-DB mükerrer kontrolü state'i
  const [multiDupResults, setMultiDupResults] = useState<any[]>([]);
  const [multiDupOpen, setMultiDupOpen] = useState(false);
  const dupeTimerRef = useRef<number | null>(null);
  const multiDupTimerRef = useRef<number | null>(null);
  // Lookup: Toptan Fiyat ve Hesap İskonto grupları
  const [priceGroupsLookup, setPriceGroupsLookup] = useState<PriceGroup[]>([]);
  const [discountGroupsLookup, setDiscountGroupsLookup] = useState<CustomerDiscountGroup[]>([]);

  // Global UI ayarları: görünürlük kontrolleri
  // Not: İlk yüklemede butonların kısa süre görünmesini (flash) engellemek için
  // varsayılanları false başlatıyoruz ve ayarlar geldikten sonra güncelliyoruz.
  const [uiShowDbSelection, setUiShowDbSelection] = useState<boolean>(false);
  const [uiShowSubCustomerButton, setUiShowSubCustomerButton] = useState<boolean>(false);
  const [uiShowOcrButton, setUiShowOcrButton] = useState<boolean>(false);
  const [uiSettingsLoaded, setUiSettingsLoaded] = useState<boolean>(false);

  // Global ayarları yükle (müşteri formu UI)
  useEffect(() => {
    let mounted = true;
    const toBool = (val: any): boolean => {
      if (val === null || val === undefined) return true; // güvenli varsayılan
      if (typeof val === 'boolean') return val;
      if (typeof val === 'string') {
        const s = val.trim().toLowerCase();
        if (s === 'true' || s === '1' || s === 'yes') return true;
        if (s === 'false' || s === '0' || s === 'no') return false;
      }
      if (typeof val === 'object' && val !== null) {
        const inner = (val as any).settingValue ?? (val as any).value ?? (val as any).SettingValue;
        return toBool(inner);
      }
      return !!val;
    };
    (async () => {
      try {
        const [s1, s2, s3] = await Promise.all([
          settingsApi.getGlobalSettingByKey('ui.customer.showDbSelection'),
          settingsApi.getGlobalSettingByKey('ui.customer.showSubCustomerButton'),
          settingsApi.getGlobalSettingByKey('ui.customer.showOcrButton'),
        ]);
        if (!mounted) return;
        setUiShowDbSelection(toBool(s1));
        setUiShowSubCustomerButton(toBool(s2));
        setUiShowOcrButton(toBool(s3));
        setUiSettingsLoaded(true);
      } catch (e) {
        // Hata durumunda varsayılanları koru (true)
        if (!mounted) return;
        setUiShowDbSelection(true);
        setUiShowSubCustomerButton(true);
        setUiShowOcrButton(true);
        setUiSettingsLoaded(true);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Price/Discount lookuplarını yükle
  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [pg, dg] = await Promise.all([
          customerLookupApi.getPriceGroups(),
          customerLookupApi.getCustomerDiscountGroups()
        ]);
        if (!mounted) return;
        setPriceGroupsLookup(Array.isArray(pg) ? pg : []);
        setDiscountGroupsLookup(Array.isArray(dg) ? dg : []);
        // Varsayılan seçimi ata: eğer ana formda seçim yoksa
        if ((!selectedWholesalePriceGroupCode || selectedWholesalePriceGroupCode === '') && Array.isArray(pg) && pg.length > 0) {
          setSelectedWholesalePriceGroupCode(DEFAULT_PRICE_GROUP_CODE || pg[0].priceGroupCode || '');
        }
        // İskonto Grubu: kullanıcı seçmediyse asla otomatik doldurma. Boş bırak.
        // Daha önce burası ilk discount grubunu (ör. '10') seçebiliyordu; bu davranışı kaldırdık.
      } catch (e) {
        console.warn('Lookup yüklenemedi (price/discount):', e);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Çoklu-DB replikasyon durumu paneli
  // Hedef DB whitelist (sabit)
  const TARGET_DBS = ['V3_StDeri', 'V3_StDeriLTD', 'V3_SerkanCanta', 'V3_SerkanCantaLTD'];
  // Kısa etiketler (gerekirse kullanıcıya göre güncellenebilir)
  const TARGET_DB_LABELS: Record<string, string> = {
    V3_StDeri: 'STD',
    V3_StDeriLTD: 'STL',
    V3_SerkanCanta: 'SCT',
    V3_SerkanCantaLTD: 'SCL',
  };
  // Görsel grup ayrımı: STD/STL ve SCT/SCL
  const GROUP_STD = new Set(['V3_StDeri', 'V3_StDeriLTD']);
  const GROUP_SCT = new Set(['V3_SerkanCanta', 'V3_SerkanCantaLTD']);

  const renderDbLabelChip = (db: string, checked: boolean) => (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: 1,
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: 1.6,
        bgcolor: GROUP_STD.has(db)
          ? alpha(theme.palette.primary.main, checked ? 0.2 : 0.08)
          : alpha(theme.palette.secondary.main, checked ? 0.2 : 0.08),
        color: checked
          ? (GROUP_STD.has(db) ? theme.palette.primary.dark : theme.palette.secondary.dark)
          : theme.palette.text.disabled,
        border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
      })}
    >
      {TARGET_DB_LABELS[db] || db}
    </Box>
  );
  // Kullanıcının seçtiği hedef DB'ler (varsayılan: tümü seçili)
  const [selectedTargetDbs, setSelectedTargetDbs] = useState<string[]>([...TARGET_DBS]);
  const [replicationVisible, setReplicationVisible] = useState(false);
  const makeInitialStatuses = () =>
    (selectedTargetDbs || []).reduce<Record<string, { status: 'pending' | 'in_progress' | 'success' | 'error'; message?: string }>>(
      (acc, db) => {
        acc[db] = { status: 'pending' };
        return acc;
      },
      {}
    );
  const [replicationStatuses, setReplicationStatuses] = useState<Record<string, { status: 'pending' | 'in_progress' | 'success' | 'error'; message?: string }>>(
    () => makeInitialStatuses()
  );

  // Bölge seçilince Müşteri Özellikleri modalını otomatik aç
  useEffect(() => {
    const region = (formData.region || (formData as any).stateCode || '').toString();
    if (!region) return;
    // Zaten açıksa veya aynı bölge için açılmışsa tekrar açma
    if (isCustomerPropertiesModalOpen) return;
    if (lastAutoOpenRegionRef.current === region) return;
    // Modalı aç ve son açılan bölgeyi kaydet
    setIsCustomerPropertiesModalOpen(true);
    lastAutoOpenRegionRef.current = region;
  }, [formData.region, isCustomerPropertiesModalOpen]);

  const { data: taxOfficesDataFromHook, isLoading: isLoadingTaxOfficesHook } = useTaxOffices();
  const { data: currenciesDataFromHook, isLoading: isLoadingCurrenciesHook } = useCurrencies();

  // Vergi dairesi alanı yanlışlıkla ad ile dolmuşsa, koda otomatik çevir (birebir/benzer eşleşme)
  useEffect(() => {
    try {
      const val = (formData.taxOffice || '').trim();
      const list = taxOfficesDataFromHook || [];
      if (!val || list.length === 0) return;
      const isValidCode = list.some((o: any) => String(o.taxOfficeCode) === val);
      if (isValidCode) return;
      // val açıklama olabilir: en iyi eşleşmeyi bul
      const code = resolveTaxOfficeCode(val, list as any[]);
      if (code) setFormData(prev => ({ ...prev, taxOffice: code }));
    } catch { /* ignore */ }
  }, [formData.taxOffice, taxOfficesDataFromHook]);

  // Konfeti efekti için state
  const [showConfetti, setShowConfetti] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  // Backend mesajları için alert/modal state
  const [backendAlert, setBackendAlert] = useState<{
    open: boolean;
    asModal: boolean;
    severity: 'success' | 'info' | 'warning' | 'error';
    title?: string;
    message?: string;
  }>({ open: false, asModal: false, severity: 'info', title: '', message: '' });

  // Pencere boyutunu izleme
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Replication durumlarında backend mesajlarını göster
  useEffect(() => {
    // Başlatılmadıysa ya da görünür değilse tetikleme
    if (!replicationStatuses) return;

    const dbs = selectedTargetDbs || [];
    const statuses = dbs.map(db => ({ db, st: replicationStatuses[db] })).filter(x => !!x.st);
    if (statuses.length === 0) return;

    const anyError = statuses.some(x => x.st.status === 'error');
    const allSuccess = statuses.length > 0 && statuses.every(x => x.st.status === 'success');

    if (anyError) {
      const firstErr = statuses.find(x => x.st.status === 'error');
      const msg = firstErr?.st?.message || 'Bilinmeyen bir hata oluştu.';
      setBackendAlert({
        open: true,
        asModal: true,
        severity: 'error',
        title: 'Müşteri Oluşturma Hatası',
        message: msg
      });
    } else if (allSuccess) {
      setBackendAlert({
        open: true,
        asModal: false,
        severity: 'success',
        title: 'Başarılı',
        message: 'Müşteri tüm veritabanlarında başarıyla oluşturuldu.'
      });
    }
  }, [replicationStatuses]);

  // Hedef DB seçimleri değiştiğinde replikasyon durumlarını sıfırla
  useEffect(() => {
    setReplicationStatuses(makeInitialStatuses());
  }, [selectedTargetDbs]);

  // SignalR: bağlantıyı bir kez kur (StrictMode güvenli)
  const connRef = useRef<signalR.HubConnection | null>(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (connRef.current) {
      return; // Zaten başlatılmış
    }
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token') || '';
    if (isDev) {
      try {
        // Debug: URL ve token uzunluğu
        // eslint-disable-next-line no-console
        console.log('[SignalR][dev] API_BASE_URL:', API_BASE_URL, 'tokenLen:', token ? token.length : 0);
      } catch {}
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_BASE_URL}/hubs/customer-progress`, {
        accessTokenFactory: () => token,
        transport: signalR.HttpTransportType.WebSockets,
        skipNegotiation: true,
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .build();

    // Event handlers
    connection.on('customer.progress', (payload: any) => {
      if (isDev) console.log('[SignalR] step:', payload);
      try {
        // requestId eşleşmesi kontrolü
        if (payload && payload.requestId && payload.requestId !== requestId) return;
        setReplicationVisible(true);
        // İlerleme adımı geldiğinde master DB'yi "in_progress" işaretleyebiliriz (isteğe bağlı)
        const db = (payload?.databaseName || payload?.targetDb || 'V3_StDeri').toString();
        setReplicationStatuses(prev => ({
          ...prev,
          [db]: { status: 'in_progress', message: payload?.message || 'İşleniyor' }
        }));
      } catch {}
    });
    connection.on('customer.replication', (payload: any) => {
      if (isDev) console.log('[SignalR] replication:', payload);
      try {
        if (payload && payload.requestId && payload.requestId !== requestId) return;
        const dbName = (payload?.databaseName || payload?.targetDb || payload?.db || '').toString();
        if (!dbName) return;
        const raw = (payload?.status || payload?.state || '').toString().toLowerCase();
        let status: 'pending' | 'in_progress' | 'success' | 'error' = 'in_progress';
        if (['ok', 'done', 'success', 'completed'].includes(raw)) status = 'success';
        else if (['err', 'error', 'failed', 'fail'].includes(raw)) status = 'error';
        else if (['pending', 'queued', 'waiting'].includes(raw)) status = 'pending';
        else status = 'in_progress';
        setReplicationVisible(true);
        setReplicationStatuses(prev => ({
          ...prev,
          [dbName]: { status, message: payload?.message }
        }));
      } catch {}
    });

    connRef.current = connection;
    setHubConnection(connection);

    let cancelled = false;
    connection
      .start()
      .then(() => {
        if (cancelled) {
          // Başlatma bittiğinde unmount olduysa temizle
          return connection.stop().catch(() => {});
        }
        startedRef.current = true;
        if (isDev) console.log('[SignalR] connected');
      })
      .catch((err: unknown) => {
        if (isDev) console.error('[SignalR] start error', err);
      });

    return () => {
      cancelled = true;
      const c = connRef.current;
      connRef.current = null;
      if (c && (c.state === signalR.HubConnectionState.Connected || c.state === signalR.HubConnectionState.Reconnecting)) {
        c.stop().catch(() => {});
      }
    };
  }, []);

  // requestId hazır olduğunda gruba katıl
  useEffect(() => {
    const c = connRef.current;
    if (!c || c.state !== signalR.HubConnectionState.Connected || !requestId) return;
    c
      .invoke('JoinRequestGroup', requestId)
      .then(() => { if (isDev) console.log('[SignalR] joined group', requestId); })
      .catch((err: unknown) => { if (isDev) console.error('[SignalR] join error', err); });
  }, [requestId]);

  // Başarı sesi çalma fonksiyonu
  const playSuccessSound = useCallback(() => {
    // Web Audio API kullanarak ses oluşturma
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // Başarı melodisi (C-E-G-C notaları)
    const playNote = (frequency: number, startTime: number, duration: number) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      
      gainNode.gain.setValueAtTime(0.3, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };
    
    // C-E-G-C melodisi
    playNote(261.63, audioContext.currentTime, 0.2); // C
    playNote(329.63, audioContext.currentTime + 0.2, 0.2); // E
    playNote(392.00, audioContext.currentTime + 0.4, 0.2); // G
    playNote(523.25, audioContext.currentTime + 0.6, 0.3); // C (bir oktav yukarı)
    
    // Havai fişek sesi efekti
    setTimeout(() => {
      const noiseBuffer = audioContext.createBuffer(
        1, audioContext.sampleRate * 0.5, audioContext.sampleRate
      );
      const output = noiseBuffer.getChannelData(0);
      
      for (let i = 0; i < noiseBuffer.length; i++) {
        output[i] = Math.random() * 2 - 1;
      }
      
      const noise = audioContext.createBufferSource();
      noise.buffer = noiseBuffer;
      
      const filter = audioContext.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 1000;
      
      const gainNode = audioContext.createGain();
      gainNode.gain.setValueAtTime(0.8, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      
      noise.connect(filter);
      filter.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      noise.start();
    }, 1000);
  }, []);

  // Hata sesi çalma fonksiyonu
  const playErrorSound = useCallback(() => {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // Üzgün "Aww" sesi
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.type = 'sine';
    oscillator.frequency.value = 300;
    oscillator.frequency.exponentialRampToValueAtTime(200, audioContext.currentTime + 0.6);
    
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.6);
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.6);
  }, []);

  // Oturum kontrolü
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
      if (!token && !isAuthenticated) {
        console.log('Oturum açılmamış, login sayfasına yönlendiriliyor...');
        try {
          // await login('admin@example.com', 'Admin123!'); // Otomatik login denemesi - Gerekirse açılabilir
        } catch (error) {
          console.error('Otomatik login hatası:', error);
          navigate('/login', { replace: true });
        }
      }
    };
    checkAuth();
  }, [isAuthenticated, login, navigate]);

  // Referans verileri yükle
  useEffect(() => {
    const loadReferenceData = async () => {
      try {
        const countriesData = await customerApi.getCountries();
        if (Array.isArray(countriesData) && countriesData.length > 0) {
          setCountries(countriesData);
        } else {
          setCountries([{ countryCode: 'TR', countryDescription: 'Türkiye' }]);
        }

        const typesData = await customerApi.getCustomerTypes();
        if (Array.isArray(typesData) && typesData.length > 0) {
          setTypes(typesData);
        }
        
        const hierarchyData = await customerApi.getLocationHierarchy('TR', 'TR');
        if (hierarchyData && hierarchyData.states) {
          setLocationHierarchy(hierarchyData);
          const stateList = hierarchyData.states.map((state: any) => ({
            code: state.stateCode,
            name: state.stateDescription
          }));
          setRegions(stateList);
        }
      } catch (error) {
        console.error('Referans verileri yüklenirken hata:', error);
      }
    };
    loadReferenceData();
  }, []);

  // Para birimleri yüklendiğinde TRY varsa varsayılanı TRY yap, yoksa ilk para birimini al
  useEffect(() => {
    if (currenciesDataFromHook && currenciesDataFromHook.length > 0) {
      const tryExists = currenciesDataFromHook.some(c => c.currencyCode === 'TRY');
      if (tryExists) {
        setFormData(prev => ({ ...prev, exchangeTypeCode: 'TRY' }));
        console.log('Para birimi varsayılan değeri TRY olarak ayarlandı');
      } else {
        setFormData(prev => ({ ...prev, exchangeTypeCode: currenciesDataFromHook[0].currencyCode }));
        console.log('TRY bulunamadı, ilk para birimi varsayılan yapıldı');
      }
    }
  }, [currenciesDataFromHook]);

  // Ülke değiştiğinde bölge ve şehir verilerini yükle
  useEffect(() => {
    const loadCountryData = async () => {
      if (formData.country === 'TR') {
        if (locationHierarchy && locationHierarchy.states && locationHierarchy.states.length > 0) return;
        try {
          const data = await customerApi.getLocationHierarchy('TR', 'TR');
          if (data && data.states) {
            setLocationHierarchy(data);
            const stateList = data.states.map((state: any) => ({
              code: state.stateCode,
              name: state.stateDescription
            }));
            setRegions(stateList);
          }
        } catch (error) {
          console.error('Lokasyon hiyerarşisi yüklenirken hata:', error);
        }
      } else {
        setRegions([]);
        setCities([]);
        setDistricts([]);
      }
    };
    loadCountryData();
  }, [formData.country, locationHierarchy]);

  // Bölge değiştiğinde şehirleri yükle
  useEffect(() => {
    if (formData.region && locationHierarchy) {
      const selectedState = locationHierarchy.states.find(
        (state: any) => state.stateCode === formData.region
      );
      if (selectedState && selectedState.cities) {
        const cityList = selectedState.cities.map((city: any) => ({
          code: city.cityCode,
          name: city.cityDescription
        }));
        setCities(cityList);
      } else {
        setCities([]);
      }
    } else {
      setCities([]);
      setDistricts([]);
    }
  }, [formData.region, locationHierarchy]);

  // Bölge seçilince: per-DB varsayılanları otomatik uygula ve payload önizlemesini logla
  useEffect(() => {
    if (!formData.region) return;

    // 1) Kullanıcı manuel seçim yapmadıysa per-DB defaultları doldur
    setPerDbSelections(prev => {
      const next = { ...prev };
      // Satış temsilcisi
      if (!next.stDeri.salesperson) next.stDeri.salesperson = resolveSalespersonByRegion(formData.region) || '';
      if (!next.serkanCanta.salesperson) next.serkanCanta.salesperson = '204';
      // Fiyat/İskonto defaultları
      if (!next.stDeri.priceGroup) next.stDeri.priceGroup = DEFAULT_PRICE_GROUP_CODE;
      if (!next.stDeri.discountGroup) next.stDeri.discountGroup = '';
      if (!next.serkanCanta.priceGroup) next.serkanCanta.priceGroup = DEFAULT_PRICE_GROUP_CODE;
      if (!next.serkanCanta.discountGroup) next.serkanCanta.discountGroup = '';
      // Fatura Şekli otomatik boş bırakılır; modal kaydederse yazılır
      return next;
    });

    // 2) Payload önizlemesi hazırla ve logla (modal kaydedilmemiş senaryo)
    try {
      const TARGET_DBS_LOCAL = ['V3_StDeri', 'V3_StDeriLTD', 'V3_SerkanCanta', 'V3_SerkanCantaLTD'];

      const regionSalesman = resolveSalespersonByRegion(formData.region);
      const perDbSalespersonCodes: Record<string, string> = {
        V3_StDeri: regionSalesman || '',
        V3_StDeriLTD: regionSalesman || '',
        V3_SerkanCanta: '204',
        V3_SerkanCantaLTD: '204',
      };

      const perDbWholesalePriceGroupCode: Record<string, string> = {
        V3_StDeri: (perDbSelections.stDeri.priceGroup || DEFAULT_PRICE_GROUP_CODE) as string,
        V3_StDeriLTD: (perDbSelections.stDeri.priceGroup || DEFAULT_PRICE_GROUP_CODE) as string,
        V3_SerkanCanta: (perDbSelections.serkanCanta.priceGroup || DEFAULT_PRICE_GROUP_CODE) as string,
        V3_SerkanCantaLTD: (perDbSelections.serkanCanta.priceGroup || DEFAULT_PRICE_GROUP_CODE) as string,
      };

      // İskonto grupları varsayılan boş olmalı (modal alanı opsiyonel)
      const perDbDiscountGroupCode: Record<string, string> = {
        V3_StDeri: '',
        V3_StDeriLTD: '',
        V3_SerkanCanta: '',
        V3_SerkanCantaLTD: '',
      };

      // Fatura Şekli per-DB yalnızca seçilmişse yazılır
      const invoiceTypeTypeCode = (() => {
        const ptypes = propertyTypes || [];
        const match = ptypes.find((t: any) => ((t.typeName || '') as string).toLowerCase().includes('fatura şekli'));
        return match ? match.typeCode : undefined;
      })();

      const perDbCustomerProperties: Record<string, Record<number, string>> = {};
      const invTypeCode = invoiceTypeTypeCode || 1;
      const stInv = perDbSelections.stDeri.invoiceType || '10';
      const scInv = perDbSelections.serkanCanta.invoiceType || '10';
      perDbCustomerProperties['V3_StDeri'] = { [invTypeCode]: stInv };
      perDbCustomerProperties['V3_StDeriLTD'] = { [invTypeCode]: stInv };
      perDbCustomerProperties['V3_SerkanCanta'] = { [invTypeCode]: scInv };
      perDbCustomerProperties['V3_SerkanCantaLTD'] = { [invTypeCode]: scInv };

      const hasDefaults = DEFAULT_CUSTOMER_PROPERTIES && Object.keys(DEFAULT_CUSTOMER_PROPERTIES).length > 0;
      const hasSelected = selectedCustomerProperties && Object.keys(selectedCustomerProperties).length > 0;
      const customerPropertiesForRequest: Record<number, string> = { ...(hasDefaults ? DEFAULT_CUSTOMER_PROPERTIES : {}) };
      if (hasSelected) {
        Object.entries(selectedCustomerProperties).forEach(([k, v]) => {
          const nk = parseInt(k, 10);
          if (!Number.isNaN(nk)) customerPropertiesForRequest[nk] = v.toString();
        });
      }

      // Konsola önizleme
      // eslint-disable-next-line no-console
      console.log('[AUTO][RegionSelected] Payload Preview (Modal kaydedilmeden):', {
        TARGET_DBS_LOCAL,
        PerDbSalespersonCodes: perDbSalespersonCodes,
        PerDbWholesalePriceGroupCode: perDbWholesalePriceGroupCode,
        PerDbDiscountGroupCode: perDbDiscountGroupCode,
        PerDbCustomerProperties: perDbCustomerProperties,
        CustomerProperties: customerPropertiesForRequest,
      });
    } catch (_) {
      // sessiz
    }
  }, [formData.region]);

  // Şehir değiştiğinde ilçeleri yükle
  useEffect(() => {
    if (formData.city && locationHierarchy && formData.region) {
      const selectedRegion = locationHierarchy.states.find((state: any) =>
        state.stateCode === formData.region
      );
      if (selectedRegion && selectedRegion.cities) {
        const selectedCity = selectedRegion.cities.find((city: any) =>
          city.cityCode === formData.city
        );
        if (selectedCity && selectedCity.districts) {
          const districtList = selectedCity.districts.map((district: any) => ({
            code: district.districtCode,
            name: district.districtDescription
          }));
          setDistricts(districtList);
        } else {
          setDistricts([]);
        }
      } else {
        setDistricts([]);
      }
    } else {
      setDistricts([]);
    }
  }, [formData.city, formData.region, locationHierarchy]);

  // Teslimat: Bölge değiştiğinde şehirleri yükle
  useEffect(() => {
    if (formData.shippingRegion && locationHierarchy) {
      const selectedState = locationHierarchy.states.find(
        (state: any) => state.stateCode === formData.shippingRegion
      );
      if (selectedState && selectedState.cities) {
        const cityList = selectedState.cities.map((city: any) => ({
          code: city.cityCode,
          name: city.cityDescription
        }));
        setShippingCities(cityList);
      } else {
        setShippingCities([]);
      }
    } else {
      setShippingCities([]);
      setShippingDistricts([]);
    }
  }, [formData.shippingRegion, locationHierarchy]);

  // Teslimat: Şehir değiştiğinde ilçeleri yükle
  useEffect(() => {
    if (formData.shippingCity && locationHierarchy && formData.shippingRegion) {
      const selectedRegion = locationHierarchy.states.find((state: any) =>
        state.stateCode === formData.shippingRegion
      );
      if (selectedRegion && selectedRegion.cities) {
        const selectedCity = selectedRegion.cities.find((city: any) =>
          city.cityCode === formData.shippingCity
        );
        if (selectedCity && selectedCity.districts) {
          const districtList = selectedCity.districts.map((district: any) => ({
            code: district.districtCode,
            name: district.districtDescription
          }));
          setShippingDistricts(districtList);
        } else {
          setShippingDistricts([]);
        }
      } else {
        setShippingDistricts([]);
      }
    } else {
      setShippingDistricts([]);
    }
  }, [formData.shippingCity, formData.shippingRegion, locationHierarchy]);

  // Mükerrer müşteri kontrolü (TCKN/VKN/Ünvan) - debounce (tek DB)
  useEffect(() => {
    try {
      if (dupeTimerRef.current) {
        window.clearTimeout(dupeTimerRef.current);
        dupeTimerRef.current = null;
      }

      const rawTc = (formData.identityNum || '').replace(/\D/g, '');
      const rawVkn = (formData.taxNumber || '').replace(/\D/g, '');
      const name = (formData.customerName || '').trim();

      const validTc = rawTc.length === 11 && validateTCNumber(rawTc);
      const validVkn = /^\d{10}$/.test(rawVkn);
      const validName = name.length >= 3;

      if (!validTc && !validVkn && !validName) {
        setDupeResults([]);
        setDupeOpen(false);
        return;
      }

      dupeTimerRef.current = window.setTimeout(async () => {
        try {
          const filter: any = { PageNumber: 1, PageSize: 5 };
          if (validTc) filter.IdentityNum = rawTc;
          if (validVkn) filter.TaxNumber = rawVkn;
          if (validName) filter.CustomerName = name;

          const res = await customerApi.getCustomers(filter as any);
          const items = (res as any)?.data?.items || (res as any)?.Data?.Items || [];
          if (Array.isArray(items) && items.length > 0) {
            setDupeResults(items);
            setDupeOpen(true);
          } else {
            setDupeResults([]);
            setDupeOpen(false);
          }
        } catch (e) {}
      }, 600);
    } catch {}
  }, [formData.identityNum, formData.taxNumber, formData.customerName]);

  // Mükellefiyet sorgusu: geçerli TCKN varsa TCKN ile, değilse geçerli VKN ile sorgula (ayrı akış)
  useEffect(() => {
    // Girdi normalizasyonu: sadece rakamlar
    const rawTax = (formData.taxNumber || '').replace(/\D/g, '');
    const rawTc = (formData.identityNum || '').replace(/\D/g, '');

    // TCKN doğrulamasını güvene al (validateTCNumber hata fırlatırsa false say)
    let hasValidTc = false;
    try {
      hasValidTc = rawTc.length === 11 && validateTCNumber(rawTc);
    } catch {
      hasValidTc = false;
    }
    const hasValidVkn = /^\d{10}$/.test(rawTax);

    if (!hasValidTc && !hasValidVkn) {
      setFormData(prev => {
        if (!prev.isSubjectToEInvoice && !prev.isSubjectToEDispatch && !prev.eInvoiceStartDate && !prev.eDispatchStartDate) return prev;
        return {
          ...prev,
          isSubjectToEInvoice: false,
          eInvoiceStartDate: null,
          isSubjectToEDispatch: false,
          eDispatchStartDate: null
        };
      });
      return;
    }

    const idToUse = hasValidTc ? rawTc : rawTax;
    if (!idToUse) return;

    const controller = new AbortController();
    const t = setTimeout(async () => {
      try {
        if (isDev) {
          // eslint-disable-next-line no-console
          console.log('[MUKELLEF][REQ] idToUse=', idToUse);
        }
        const results = await Promise.allSettled([
          axiosInstance.get(`/api/v1/Customer/e-invoice-inquiry/${idToUse}`, { signal: controller.signal }),
          axiosInstance.get(`/api/v1/Customer/e-shipment-inquiry/${idToUse}`, { signal: controller.signal }),
        ]);

        const invRes = results[0].status === 'fulfilled' ? results[0].value : undefined;
        const shipRes = results[1].status === 'fulfilled' ? results[1].value : undefined;

        const inv = invRes?.data?.data;
        const ship = shipRes?.data?.data;

        if (isDev) {
          // eslint-disable-next-line no-console
          console.log('[MUKELLEF][RESP] invoice=', invRes?.data, 'shipment=', shipRes?.data);
        }

        const invoiceFound = !!(inv && inv.found);
        const shipmentFound = !!(ship && ship.found);

        setFormData(prev => {
          const next = { ...prev } as any;
          const fetchedName = inv?.titleName || inv?.companyName || ship?.titleName || ship?.companyName;
          if (fetchedName) next.customerName = fetchedName;

          next.isSubjectToEInvoice = invoiceFound;
          next.eInvoiceStartDate = invoiceFound
            ? (inv?.startDate ? new Date(inv.startDate) : (prev.eInvoiceStartDate || new Date()))
            : null;

          const dispatchFlag = shipmentFound || !!inv?.isSubjectToEShipment;
          next.isSubjectToEDispatch = dispatchFlag;
          next.eDispatchStartDate = dispatchFlag
            ? (ship?.startDate ? new Date(ship.startDate)
              : inv?.startDate ? new Date(inv.startDate)
              : (prev.eDispatchStartDate || new Date()))
            : null;

          if (!invoiceFound && !shipmentFound && !inv?.isSubjectToEShipment) {
            next.isSubjectToEDispatch = false;
            next.eDispatchStartDate = null;
          }

          return next;
        });

        // Kullanıcıya durum mesajı göster
        try {
          const parts: string[] = [];
          if (invoiceFound) parts.push('E-Fatura: var'); else parts.push('E-Fatura: yok');
          if (shipmentFound || inv?.isSubjectToEShipment) parts.push('E-İrsaliye: var'); else parts.push('E-İrsaliye: yok');
          const anyFound = invoiceFound || shipmentFound || !!inv?.isSubjectToEShipment;
          setSnackbar({
            open: true,
            severity: anyFound ? 'success' : 'error',
            message: anyFound ? `Mükellef bulundu (${parts.join(' • ')})` : `Mükellef bulunamadı (${parts.join(' • ')})`
          });
        } catch (_) { /* sessiz */ }
      } catch (err) {
        if (isDev) {
          // eslint-disable-next-line no-console
          console.error('[MUKELLEF][ERR]', err);
        }
      }
    }, 350);

    return () => { clearTimeout(t); controller.abort(); };
  }, [formData.taxNumber, formData.identityNum]);

  // Çoklu-DB mükerrer kontrolü (TCKN/VKN) - debounce
  useEffect(() => {
    try {
      if (multiDupTimerRef.current) {
        window.clearTimeout(multiDupTimerRef.current);
        multiDupTimerRef.current = null;
      }

      const rawTc = (formData.identityNum || '').replace(/\D/g, '');
      const rawVkn = (formData.taxNumber || '').replace(/\D/g, '');
      const validTc = rawTc.length === 11 && validateTCNumber(rawTc);
      const validVkn = /^\d{10}$/.test(rawVkn);

      if (!validTc && !validVkn) {
        setMultiDupResults([]);
        setMultiDupOpen(false);
        return;
      }

      multiDupTimerRef.current = window.setTimeout(async () => {
        try {
          const res = await customerApi.multiDbDupCheck({
            identityNum: validTc ? rawTc : undefined,
            taxNumber: validVkn ? rawVkn : undefined
          } as any);
          const list = (res as any)?.data || (res as any)?.Data || [];
          if (Array.isArray(list) && list.length > 0) {
            setMultiDupResults(list);
            setMultiDupOpen(true);
          } else {
            setMultiDupResults([]);
            setMultiDupOpen(false);
          }
        } catch (_) {
          // sessiz
        }
      }, 600);
    } catch {}
  }, [formData.identityNum, formData.taxNumber]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // TC Kimlik ve vergi numarası doğrulaması
    if (name === 'taxNumber' && value.length > 0) {
      // Sadece rakam girişine izin ver
      if (!/^\d*$/.test(value)) {
        return; // Rakam değilse işlemi durdur
      }
      
      // Maksimum 10 karakter sınırlaması
      if (value.length > 10) {
        return; // 10 karakterden fazla ise işlemi durdur
      }
    }
    
    if (name === 'identityNum' && value.length > 0) {
      // Sadece rakam girişine izin ver
      if (!/^\d*$/.test(value)) {
        return; // Rakam değilse işlemi durdur
      }
      
      // Maksimum 11 karakter sınırlaması
      if (value.length > 11) {
        return; // 11 karakterden fazla ise işlemi durdur
      }
    }
    
    setFormData(prev => {
      
      // Eğer müşteri adı değişiyorsa ve gerçek kişi ise, firstName alanını da güncelle (detaylı mod için)
      if (name === 'customerName' && prev.isIndividual && prev.formType === 'detailed') {
        return { ...prev, [name]: value, firstName: value };
      }
      
      // Eğer firstName veya lastName değişiyorsa ve gerçek kişi ise, müşteri açıklamasını otomatik oluştur
      if ((name === 'firstName' || name === 'lastName') && prev.isIndividual) {
        const updatedData = { ...prev, [name]: value };
        // Ad ve soyadı birleştirerek müşteri açıklaması oluştur
        if (name === 'firstName' && updatedData.lastName) {
          updatedData.customerName = `${value} ${updatedData.lastName}`;
        } else if (name === 'lastName' && updatedData.firstName) {
          updatedData.customerName = `${updatedData.firstName} ${value}`;
        }
        return updatedData;
      }
      
      return { ...prev, [name]: value };
    });
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name as string]: value }));
  };
  
  // OCR: dosya seçim diyalogunu aç
  const handleOcrBrowse = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // OCR: modal içindeki alan değişikliklerini işle
  const handleOcrEditChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setOcrEdit(prev => {
      if (!prev) return prev;
      return { ...prev, [name]: value } as OcrExtractResult;
    });
    // Vergi dairesi metni değiştiğinde otomatik kod çözümlemesi yap
    if (name === 'taxOffice') {
      try {
        const input = (value || '').trim();
        if (input) {
          // 1) Backend DB resolver (region/city/district/taxOffice)
          (async () => {
            try {
              const loc = await aiApi.resolveLocation({
                region: String(ocrEdit?.region || ''),
                city: String(ocrEdit?.city || ''),
                district: String(ocrEdit?.district || ''),
                taxOffice: input
              });
              const codeFromDb = loc?.data?.taxOfficeCode;
              if (codeFromDb) {
                setOcrTaxOfficeCode(String(codeFromDb));
                setFormData(prev => ({ ...prev, taxOffice: String(codeFromDb) }));
                return;
              }
            } catch {}
            // 2) Backend AI resolver (liste göndermeden)
            try {
              const resp = await aiApi.resolveTaxOffice({
                freeText: input,
                cityCode: String(formData.city || ''),
                districtCode: String(formData.district || ''),
                offices: []
              });
              if (resp && resp.code) {
                setOcrTaxOfficeCode(String(resp.code));
                setFormData(prev => ({ ...prev, taxOffice: String(resp.code) }));
                return;
              }
            } catch {}
            // 3) Backend yoksa yerel çöz
            if (Array.isArray(taxOfficesDataFromHook)) {
              const codeLocal = resolveTaxOfficeCode(input, taxOfficesDataFromHook as any[]);
              if (codeLocal) {
                setOcrTaxOfficeCode(codeLocal);
                setFormData(prev => ({ ...prev, taxOffice: codeLocal }));
                return;
              }
              const best = resolveTaxOfficeBestCandidate(input, taxOfficesDataFromHook as any[]);
              if (best) {
                setOcrTaxOfficeCode(best.code);
                setFormData(prev => ({ ...prev, taxOffice: best.code }));
                setSnackbar({ open: true, severity: 'success', message: `Vergi dairesi otomatik eşleştirildi: ${best.description}` });
                return;
              }
            }
            setOcrTaxOfficeCode('');
          })();
        } else {
          setOcrTaxOfficeCode('');
        }
      } catch {
        setOcrTaxOfficeCode('');
      }
    }
  };

  // Yardımcı: Türkçe karakterleri normalize ederek karşılaştırma yap
  const normalizeTr = (s?: string) =>
    (s || '')
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/i̇/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/â|î|û/g, m => ({ 'â': 'a', 'î': 'i', 'û': 'u' }[m] as string))
      .trim();

  // Büyük harf normalize yardımcı (Türkçe karakterleri sadeleştirip BÜYÜK yapar)
  const normalizeTrUpper = (s?: string) => normalizeTr(s).toUpperCase();

  // Dice Coefficient (bigram) benzerlik ölçümü [0..1]
  const diceCoefficient = (a: string, b: string): number => {
    if (!a || !b) return 0;
    if (a === b) return 1;
    const bigrams = (str: string) => {
      const arr: string[] = [];
      for (let i = 0; i < str.length - 1; i++) arr.push(str.slice(i, i + 2));
      return arr;
    };
    const aB = bigrams(a);
    const bB = bigrams(b);
    if (aB.length === 0 || bB.length === 0) return 0;
    let matches = 0;
    const bMap = new Map<string, number>();
    bB.forEach(bg => bMap.set(bg, (bMap.get(bg) || 0) + 1));
    for (const bg of aB) {
      const cnt = bMap.get(bg) || 0;
      if (cnt > 0) {
        matches++;
        bMap.set(bg, cnt - 1);
      }
    }
    return (2 * matches) / (aB.length + bB.length);
  };

  // Vergi dairesi kodunu metinden çözümleyen yardımcı: önce birebir, sonra içerir, sonra en yakın
  const resolveTaxOfficeCode = (inputRaw: string, list: any[]): string => {
    if (!inputRaw || !Array.isArray(list) || list.length === 0) return '';
    // yaygın ekleri sil ve normalize
    let nInput = normalizeTrUpper(inputRaw)
      .replace(/\bVERGI\s*DAIRESI\s*BASKANLIGI\b/g, '')
      .replace(/\bVERGI\s*DAIRESI\b/g, '')
      .replace(/\bVD\b/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    // 1) Kod ile birebir
    let match = list.find((o: any) => normalizeTrUpper(o.taxOfficeCode) === nInput);
    if (match) return String(match.taxOfficeCode);
    // 2) Ad ile birebir
    match = list.find((o: any) => normalizeTrUpper(o.taxOfficeDescription) === nInput);
    if (match) return String(match.taxOfficeCode);
    // 3) İcerir eşleşmeleri (hem ileri hem geri)
    match = list.find((o: any) => normalizeTrUpper(o.taxOfficeDescription).includes(nInput) || nInput.includes(normalizeTrUpper(o.taxOfficeDescription)));
    if (match) return String(match.taxOfficeCode);
    // 4) En yakın (benzerlik)
    let best: { code: string; score: number } = { code: '', score: 0 };
    list.forEach((o: any) => {
      const codeU = normalizeTrUpper(o.taxOfficeCode);
      const descU = normalizeTrUpper(o.taxOfficeDescription);
      const score = Math.max(diceCoefficient(nInput, descU), diceCoefficient(nInput, codeU));
      if (score > best.score) best = { code: String(o.taxOfficeCode), score };
    });
    // Eşik 0.55
    return best.score >= 0.55 ? best.code : '';
  };

  const resolveTaxOfficeBestCandidate = (inputRaw: string, list: any[]): { code: string; description: string; score: number } | null => {
    if (!inputRaw || !Array.isArray(list) || list.length === 0) return null;
    let nInput = normalizeTrUpper(inputRaw)
      .replace(/\bVERGI\s*DAIRESI\s*BASKANLIGI\b/g, '')
      .replace(/\bVERGI\s*DAIRESI\b/g, '')
      .replace(/\bVD\b/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    let best: { code: string; description: string; score: number } = { code: '', description: '', score: 0 };
    list.forEach((o: any) => {
      const codeU = normalizeTrUpper(o.taxOfficeCode);
      const descU = normalizeTrUpper(o.taxOfficeDescription);
      const score = Math.max(diceCoefficient(nInput, descU), diceCoefficient(nInput, codeU));
      if (score > best.score) best = { code: String(o.taxOfficeCode), description: String(o.taxOfficeDescription), score };
    });
    return best.code ? best : null;
  };

  // OCR verisini forma uygula
  const applyOcrToForm = async () => {
    if (!ocrEdit) return;

    // Bölge/şehir/ilçe adlarını koda çevir
    let regionCode = '' as string;
    let cityCode = '' as string;
    let districtCode = '' as string;

    try {
      if (locationHierarchy && Array.isArray(locationHierarchy.states)) {
        const nRegion = normalizeTr((ocrEdit.region || '').trim());
        const nCity = normalizeTr((ocrEdit.city || '').trim());
        const nDistrict = normalizeTr((ocrEdit.district || '').trim());

        const st = locationHierarchy.states.find((s: any) =>
          normalizeTr(s.stateDescription) === nRegion || normalizeTr(s.stateCode) === nRegion
        );
        if (st) {
          regionCode = st.stateCode;
          if (Array.isArray(st.cities)) {
            const ct = st.cities.find((c: any) =>
              normalizeTr(c.cityDescription) === nCity || normalizeTr(c.cityCode) === nCity
            );
            if (ct) {
              cityCode = ct.cityCode;
              if (Array.isArray(ct.districts)) {
                let dt = ct.districts.find((d: any) =>
                  normalizeTr(d.districtDescription) === nDistrict || normalizeTr(d.districtCode) === nDistrict
                );
                if (!dt) {
                  const isMerkezLike = !nDistrict || normalizeTrUpper(nDistrict) === 'MERKEZ';
                  if (isMerkezLike) {
                    const cityU = normalizeTrUpper(String(ct.cityDescription || ''));
                    const candidates = (ct.districts as any[]).filter((d: any) =>
                      normalizeTrUpper(String(d.districtDescription || '')).includes('MERKEZ')
                    );
                    dt = candidates.find((d: any) =>
                      normalizeTrUpper(String(d.districtDescription || '')).includes(`(${cityU})`)
                    ) || candidates.find((d: any) => normalizeTrUpper(String(d.districtDescription || '')) === 'MERKEZ') || candidates[0];
                  }
                }
                if (dt) districtCode = dt.districtCode;
              }
            }
          }
        }
      }
    } catch (_) {
      // mapping hataları sessiz geçilir
    }

    // Vergi dairesi metnini (OCR) koda çevir
    let taxOfficeCodeResolved = '' as string;
    try {
      const input = (ocrEdit.taxOffice || '').trim();
      if (input && Array.isArray(taxOfficesDataFromHook)) {
        taxOfficeCodeResolved = resolveTaxOfficeCode(input, taxOfficesDataFromHook as any[]);
      }
    } catch (_) { /* sessiz */ }

    // Kişi/tüzel tespiti
    const rawTc = ((ocrEdit.identityNum || '').trim()).replace(/\D/g, '');
    const rawVkn = ((ocrEdit.taxNumber || '').trim()).replace(/\D/g, '');
    const isIndividual = rawTc.length === 11;

    const companyTrimmed = (ocrEdit.companyName || '').trim();
    let firstName = '';
    let lastName = '';
    if (isIndividual) {
      const parts = companyTrimmed.split(/\s+/).filter(Boolean);
      if (parts.length === 1) {
        firstName = parts[0];
        lastName = '';
      } else if (parts.length > 1) {
        lastName = parts.pop() as string;
        firstName = parts.join(' ');
      }
    }

    setFormData(prev => ({
      ...prev,
      country: 'TR',
      region: regionCode || prev.region,
      city: cityCode || prev.city,
      district: districtCode || prev.district,
      address: (ocrEdit.address || '').trim() || prev.address,
      customerName: isIndividual ? `${firstName}${lastName ? ' ' + lastName : ''}` : (companyTrimmed || prev.customerName),
      // OCR modalındaki seçimi önceliklendir, yoksa metinden çözümlediğimizi kullan
      taxOffice: (ocrTaxOfficeCode || taxOfficeCodeResolved || prev.taxOffice),
      taxNumber: rawVkn || prev.taxNumber,
      identityNum: rawTc || prev.identityNum,
      isIndividual,
      firstName: isIndividual ? firstName : prev.firstName,
      lastName: isIndividual ? lastName : prev.lastName,
      authPhone: (ocrEdit.phone || '').trim() || prev.authPhone,
      accountingPhone: (ocrEdit.phone || '').trim() || prev.accountingPhone,
      authEmail: (ocrEdit.email || '').trim() || prev.authEmail,
      accountingEmail: (ocrEdit.email || '').trim() || prev.accountingEmail,
    }));

    setSnackbar({ open: true, severity: 'success', message: 'OCR verisi forma aktarıldı.' });
    handleCloseOcrModal();

    // Mükellef sorgulama: Önce VKN ile dene, bulunamazsa TCKN ile dene
    try {
      const tryIds: string[] = [];
      if (rawVkn && rawVkn.length === 10) tryIds.push(rawVkn);
      if (rawTc && rawTc.length === 11) tryIds.push(rawTc);

      // E-Fatura sorgusu
      let einvData: any | null = null;
      for (const id of tryIds) {
        try {
          const resp: any = await customerService.getEInvoiceInfoByTaxId(id);
          const data = resp?.data?.data ?? resp?.data ?? resp?.Data ?? null;
          const found = data?.Found ?? data?.found;
          if (found === true) { einvData = data; break; }
        } catch (_) { /* sessiz */ }
      }

      // E-İrsaliye sorgusu
      let eshipData: any | null = null;
      for (const id of tryIds) {
        try {
          const resp: any = await customerService.getEShipmentInfoByTaxId(id);
          const data = resp?.data?.data ?? resp?.data ?? resp?.Data ?? null;
          const found = data?.Found ?? data?.found;
          if (found === true) { eshipData = data; break; }
        } catch (_) { /* sessiz */ }
      }

      if (einvData || eshipData) {
        setFormData(prev => ({
          ...prev,
          isSubjectToEInvoice: Boolean((einvData?.IsSubjectToEInvoice ?? einvData?.isSubjectToEInvoice) ?? prev.isSubjectToEInvoice),
          eInvoiceStartDate: einvData?.StartDate ? new Date(einvData.StartDate) : prev.eInvoiceStartDate,
          isSubjectToEDispatch: Boolean((eshipData?.IsSubjectToEShipment ?? eshipData?.isSubjectToEShipment ?? einvData?.IsSubjectToEShipment ?? einvData?.isSubjectToEShipment) ?? prev.isSubjectToEDispatch),
          eDispatchStartDate: eshipData?.StartDate ? new Date(eshipData.StartDate) : prev.eDispatchStartDate,
        }));
      }
    } catch (err) {
      console.warn('Mükellef sorgulama hatası:', err);
    }
  };

  // OCR: dosya seçildiğinde modalı hemen aç, görsel önizleme ve tarama animasyonu göster; arka planda isteği başlat
  const handleOcrFileSelected = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    // Eski URL'yi temizle
    setOcrPreview(null);
    setOcrEdit(null);
    setIsOcrLoading(true);
    setOcrModalOpen(true);
    try {
      if (ocrImageUrl) {
        try { URL.revokeObjectURL(ocrImageUrl); } catch {}
      }
      const url = URL.createObjectURL(file);
      setOcrImageUrl(url);
      const res = await extractCustomerFromImage(file);
      setOcrPreview(res);
      setOcrEdit(res);
      // OCR çıktısından vergi dairesi kodunu çözümle ve modal seçimine uygula
      try {
        const input = (res?.taxOffice || '').trim();
        if (input) {
          // 1) Backend DB resolver (region/city/district/taxOffice)
          try {
            const loc = await aiApi.resolveLocation({
              region: String(res?.region || ''),
              city: String(res?.city || ''),
              district: String(res?.district || ''),
              taxOffice: input
            });
            const codeFromDb = loc?.data?.taxOfficeCode;
            if (codeFromDb) {
              setOcrTaxOfficeCode(String(codeFromDb));
              setFormData(prev => ({ ...prev, taxOffice: String(codeFromDb) }));
            } else if (Array.isArray(taxOfficesDataFromHook)) {
              const codeLocal = resolveTaxOfficeCode(input, taxOfficesDataFromHook as any[]);
              if (codeLocal) {
                setOcrTaxOfficeCode(codeLocal);
                setFormData(prev => ({ ...prev, taxOffice: codeLocal }));
              } else {
                // 2) Backend AI resolver
                try {
                  const resp = await aiApi.resolveTaxOffice({
                    freeText: input,
                    cityCode: String(formData.city || ''),
                    districtCode: String(formData.district || ''),
                    offices: []
                  });
                  if (resp?.code) {
                    setOcrTaxOfficeCode(String(resp.code));
                    setFormData(prev => ({ ...prev, taxOffice: String(resp.code) }));
                  } else {
                    const best = resolveTaxOfficeBestCandidate(input, taxOfficesDataFromHook as any[]);
                    if (best) {
                      setOcrTaxOfficeCode(best.code);
                      setFormData(prev => ({ ...prev, taxOffice: best.code }));
                      setSnackbar({ open: true, severity: 'success', message: `Vergi dairesi otomatik eşleştirildi: ${best.description}` });
                    } else {
                      setOcrTaxOfficeCode('');
                    }
                  }
                } catch {
                  const best = resolveTaxOfficeBestCandidate(input, taxOfficesDataFromHook as any[]);
                  if (best) {
                    setOcrTaxOfficeCode(best.code);
                    setFormData(prev => ({ ...prev, taxOffice: best.code }));
                    setSnackbar({ open: true, severity: 'success', message: `Vergi dairesi otomatik eşleştirildi: ${best.description}` });
                  } else {
                    setOcrTaxOfficeCode('');
                  }
                }
              }
            } else {
              setOcrTaxOfficeCode('');
            }
          } catch {
            // Backend hatasında yerel + AI fallback
            if (Array.isArray(taxOfficesDataFromHook)) {
              const codeLocal = resolveTaxOfficeCode(input, taxOfficesDataFromHook as any[]);
              if (codeLocal) {
                setOcrTaxOfficeCode(codeLocal);
                setFormData(prev => ({ ...prev, taxOffice: codeLocal }));
              } else {
                try {
                  const resp = await aiApi.resolveTaxOffice({
                    freeText: input,
                    cityCode: String(formData.city || ''),
                    districtCode: String(formData.district || ''),
                    offices: []
                  });
                  if (resp?.code) {
                    setOcrTaxOfficeCode(String(resp.code));
                    setFormData(prev => ({ ...prev, taxOffice: String(resp.code) }));
                  } else {
                    const best = resolveTaxOfficeBestCandidate(input, taxOfficesDataFromHook as any[]);
                    if (best) {
                      setOcrTaxOfficeCode(best.code);
                      setFormData(prev => ({ ...prev, taxOffice: best.code }));
                      setSnackbar({ open: true, severity: 'success', message: `Vergi dairesi otomatik eşleştirildi: ${best.description}` });
                    } else {
                      setOcrTaxOfficeCode('');
                    }
                  }
                } catch {
                  const best = resolveTaxOfficeBestCandidate(input, taxOfficesDataFromHook as any[]);
                  if (best) {
                    setOcrTaxOfficeCode(best.code);
                    setFormData(prev => ({ ...prev, taxOffice: best.code }));
                    setSnackbar({ open: true, severity: 'success', message: `Vergi dairesi otomatik eşleştirildi: ${best.description}` });
                  } else {
                    setOcrTaxOfficeCode('');
                  }
                }
              }
            } else {
              setOcrTaxOfficeCode('');
            }
          }
        } else {
          setOcrTaxOfficeCode('');
        }
      } catch {
        setOcrTaxOfficeCode('');
      }
    } catch (err: any) {
      console.error('OCR hata:', err);
      setSnackbar({ open: true, severity: 'error', message: err?.message || 'OCR sırasında hata oluştu.' });
    } finally {
      setIsOcrLoading(false);
      if (e.target) e.target.value = '';
    }
  };

  // Checkbox değişimleri
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData(prev => {
      // Gerçek Kişi/Şahıs switch'i tetiklendiğinde (yön fark etmeksizin)
      // TC Kimlik, Ad, Soyad ve Vergi Numarası alanlarını temizle
      if (name === 'isIndividual') {
        return {
          ...prev,
          [name]: checked,
          identityNum: '',
          firstName: '',
          lastName: '',
          // Vergi numarası (VKN) bireyselde de korunacak, bu nedenle silme
        };
      }

      // E-Fatura veya E-İrsaliye checkbox'ları için tarih alanlarını ayarla
      if (name === 'isSubjectToEInvoice' && checked && !prev.eInvoiceStartDate) {
        return { ...prev, [name]: checked, eInvoiceStartDate: new Date() };
      }
      
      if (name === 'isSubjectToEDispatch' && checked && !prev.eDispatchStartDate) {
        return { ...prev, [name]: checked, eDispatchStartDate: new Date() };
      }
      
      return { ...prev, [name]: checked };
    });
  };

  const handleDateChange = (name: string, value: string) => {
    setFormData(prev => ({ ...prev, [name]: value ? new Date(value) : null }));
  };
  
  // Hedef veritabanı seçim toggle - aynı gruptan çift seçim zorunlu (STD ikilisi ya da SCT ikilisi)
  const toggleTargetDb = (db: string) => {
    setSelectedTargetDbs((prev) => {
      const isStd = GROUP_STD.has(db);
      const group = isStd ? GROUP_STD : GROUP_SCT;
      const prevSet = new Set(prev || []);
      const groupAllSelected = Array.from(group).every(x => prevSet.has(x));

      // Tıklanan grubun çifti birlikte toggle edilir; diğer gruba dokunulmaz
      if (groupAllSelected) {
        Array.from(group).forEach(x => prevSet.delete(x));
      } else {
        Array.from(group).forEach(x => prevSet.add(x));
      }

      return Array.from(prevSet);
    });
  };
  
  // Form sıfırlama fonksiyonu
  const resetForm = () => {
    setFormData({
      formType: 'detailed',
      customerType: '3',
      // Detaylı modda tüzel kişi varsayılan açık
      isIndividual: false,
      country: 'TR',
      region: '',
      city: '',
      district: '',
      taxOffice: '',
      taxNumber: '',
      identityNum: '',
      firstName: '',
      lastName: '',
      customerName: '',
      address: '',
      authPhone: '',
      accountingPhone: '',
      authEmail: '',
      accountingEmail: '',
      contactName: '',
      isSubjectToEInvoice: false,
      eInvoiceStartDate: null,
      isSubjectToEDispatch: false,
      eDispatchStartDate: null,
      exchangeTypeCode: 'TRY',
      // Teslimat adresi alanları
      isShippingSameAsBilling: true,
      shippingRegion: '',
      shippingCity: '',
      shippingDistrict: '',
      shippingAddress: '',
    });
    // Alt müşteriler ve modal durumu da temizlensin
    setSubCustomers([]);
    setIsSubCustomersModalOpen(false);
  };

  // Backend alert kapatma
  const handleCloseBackendAlert = () => {
    setBackendAlert(prev => ({ ...prev, open: false }));
  };

  // Snackbar kapatma fonksiyonu
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // OCR modal kapatma
  const handleCloseOcrModal = () => {
    setOcrModalOpen(false);
    setOcrPreview(null);
    setOcrEdit(null);
    setOcrTaxOfficeCode('');
    if (ocrImageUrl) {
      try { URL.revokeObjectURL(ocrImageUrl); } catch {}
    }
    setOcrImageUrl(null);
  };
  
  // Müşteri oluşturma işlemi
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Çift tıklama/tekrar submit'i engelle
    if (isLoading) return;
    // Çoklu-DB duplikasyon tespit edildiyse kaydı durdur
    if (multiDupResults && multiDupResults.length > 0) {
      setSnackbar({ open: true, severity: 'error', message: 'Çoklu veritabanında eşleşen kayıtlar bulundu. Lütfen kontrol edip gerekirse mevcut kaydı kullanın.' });
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch {}
      return;
    }
    // Hedef DB seçimi: yalnızca 2 veya 4 adet seçili olabilir (tek ya da 3 olmaz)
    const selCount = (selectedTargetDbs || []).length;
    if (selCount !== 2 && selCount !== 4) {
      setSnackbar({ open: true, severity: 'error', message: 'Lütfen 2 veya 4 veritabanı seçiniz.' });
      return;
    }
    // 2 seçim yapıldıysa bu STD çifti veya SCT çifti olmalı
    if (selCount === 2) {
      const sel = new Set(selectedTargetDbs || []);
      const stdPair = Array.from(GROUP_STD);
      const sctPair = Array.from(GROUP_SCT);
      const isStdPair = stdPair.every(x => sel.has(x));
      const isSctPair = sctPair.every(x => sel.has(x));
      if (!isStdPair && !isSctPair) {
        setSnackbar({ open: true, severity: 'error', message: '2 seçim yapılacaksa STD çifti (V3_StDeri, V3_StDeriLTD) veya SCT çifti (V3_SerkanCanta, V3_SerkanCantaLTD) seçilmelidir.' });
        return;
      }
    }
    setIsLoading(true);
    // Replikasyon panelini baştan hazırla
    setReplicationStatuses(makeInitialStatuses());
    setReplicationVisible(true);
    let errorMessage = '';

    try {
      // Temel doğrulama
      if (!formData.customerName || formData.customerName.trim() === '') {
        errorMessage = 'Müşteri adı alanı zorunludur';
        throw new Error(errorMessage);
      } 
      
      // İletişim bilgileri: Yetkili kişi telefonu ve e-postası zorunlu
      if (!formData.authPhone || formData.authPhone.trim() === '') {
        errorMessage = 'Yetkili Kişi Telefonu zorunludur';
        throw new Error(errorMessage);
      }
      if (!formData.authEmail || formData.authEmail.trim() === '') {
        errorMessage = 'Yetkili Kişi E-posta zorunludur';
        throw new Error(errorMessage);
      }
      // Basit e-posta format kontrolü
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.authEmail.trim())) {
        errorMessage = 'Geçersiz e-posta formatı';
        throw new Error(errorMessage);
      }
      
      // TC Kimlik numarası doğrulaması
      if (formData.country === 'TR' && formData.isIndividual && formData.identityNum) {
        if (!validateTCNumber(formData.identityNum)) {
          errorMessage = 'Geçersiz TC Kimlik numarası. TC Kimlik numarası 11 haneli sayı olmalıdır.';
          throw new Error(errorMessage);
        }
      } 
      
      // Vergi numarası doğrulaması
      if (formData.country === 'TR' && !formData.isIndividual && formData.taxNumber) {
        if (!validateTaxNumber(formData.taxNumber)) {
          errorMessage = 'Geçersiz vergi numarası. Vergi numarası 10 haneli olmalı ve tüm karakterler rakam olmalıdır.';
          throw new Error(errorMessage);
        }
      }

      // Varsayılan değerleri uygula
      let phoneToUse = formData.authPhone;
      let emailToUse = formData.authEmail;
      let identityNumToUse = formData.identityNum;
      
      // Telefon girilmemişse varsayılan telefon numarası
      if (!formData.authPhone || formData.authPhone.trim() === '') {
        phoneToUse = '90-555-555-55-55';
      }
      
      // E-mail girilmemişse varsayılan e-mail
      if (!formData.authEmail || formData.authEmail.trim() === '') {
        emailToUse = 'test@edikravat.tr';
      }
      
      // TC kimlik ve vergi dairesi boşsa varsayılan TC kimlik
      if (formData.country === 'TR' && formData.isIndividual && 
          (!formData.identityNum || formData.identityNum.trim() === '') && 
          (!formData.taxNumber || formData.taxNumber.trim() === '')) {
        identityNumToUse = '12345678901';
      }

      // Form tipine göre doğrulama
      if (formData.formType === 'detailed') {
        // Detaylı form için ek doğrulamalar
        if (formData.isIndividual) {
          // Bireysel müşteri için doğrulamalar - varsayılan değer kullanılacağı için zorunluluk kaldırıldı
          // TC kimlik numarası varsa doğrula
          if (identityNumToUse && !validateTCNumber(identityNumToUse)) {
            errorMessage = 'Geçersiz TC Kimlik numarası. TC Kimlik numarası 11 haneli sayı olmalıdır.';
            throw new Error(errorMessage);
          }
        } else {
          // Kurumsal müşteri için doğrulamalar
          if (!formData.taxNumber || formData.taxNumber.trim() === '') {
            errorMessage = 'Vergi Numarası zorunludur';
            throw new Error(errorMessage);
          }
          if (!formData.taxOffice || formData.taxOffice.trim() === '') {
            errorMessage = 'Vergi Dairesi zorunludur';
            throw new Error(errorMessage);
          }
        }
      }

      // Bölgeye göre satış sorumlusu (frontend merkezli atama)
      const regionSalesman = resolveSalespersonByRegion(formData.region);

      // İsim alanlarını gönderim için hazırlayalım
      const submitFirstName = formData.isIndividual ? (formData.firstName || formData.customerName) : formData.customerName;
      const submitLastName = formData.isIndividual ? (formData.lastName || '') : '';

      // TypeScript için any tipini kullanarak genişletilebilir nesne oluştur
      const customerData: any = {
        // Zorunlu alanlar - CustomerCreateRequestNew modeline uygun
        companyCode: 1, // byte - Şirket kodu
        officeCode: "M", // string - Ofis kodu
        customerName: submitFirstName, // Gerçek kişi: Ad | Tüzel: Ünvan
        customerTypeCode: parseInt(formData.customerType) || 3, // byte - Müşteri tipi (3 = Müşteri, 1 = Tedarikçi)
        dataLanguageCode: "TR", // string - Dil kodu
        createdUserName: localStorage.getItem('userName') || 'system', // string - Oluşturan kullanıcı
        lastUpdatedUserName: localStorage.getItem('userName') || 'system', // string - Son güncelleyen kullanıcı
        
        // Diğer alanlar
        customerSurname: submitLastName, // Gerçek kişi: Soyad | Tüzel: boş
        identityNum: identityNumToUse, // string - TC kimlik numarası
        barcodeTypeCode: "1", // string - Barkod tipi
        dbsAccountCode: "", // string - DBS hesap kodu
        paymentTerm: 0, // int - Ödeme vadesi
        creditLimit: 0.0, // decimal - Kredi limiti
        riskLimit: 0.0, // decimal - Risk limiti
        minBalance: 0.0, // decimal - Minimum bakiye
        isVIP: false, // bool - VIP müşteri mi
        isSendAdvertSMS: false, // bool - Reklam SMS'i gönderilsin mi
        isSendAdvertMail: false, // bool - Reklam e-postası gönderilsin mi
        isBlocked: false, // bool - Bloke mi
        isLocked: false, // bool - Kilitli mi
        useDBSIntegration: false, // bool - DBS entegrasyonu kullanılsın mı
        isIndividualAcc: !!formData.isIndividual, // bool - Bireysel hesap mı
        promotionGroupCode: "", // string - Promosyon grup kodu
        isSubjectToEInvoice: !!formData.isSubjectToEInvoice, // bool - E-Fatura kapsamında mı
        isSubjectToEShipment: !!formData.isSubjectToEDispatch, // bool - E-İrsaliye kapsamında mı
        // Backend NOT NULL kısıtından dolayı null göndermemek için sentinel tarih kullanıyoruz
        eInvoiceStartDate: formData.isSubjectToEInvoice
          ? (formData.eInvoiceStartDate || new Date())
          : new Date('1900-01-01T00:00:00Z'),
        eShipmentStartDate: formData.isSubjectToEDispatch
          ? (formData.eDispatchStartDate || new Date())
          : new Date('1900-01-01T00:00:00Z')
      };

      // Per-DB alanlarını hazırlacustomerRegistration.form.accountingEmail.label
      // Fatura Şekli property typeCode'unu bul
      const invoiceTypeTypeCode = (() => {
        const ptypes = propertyTypes || [];
        const match = ptypes.find((t: any) => ((t.typeName || '') as string).toLowerCase().includes('fatura şekli'));
        return match ? match.typeCode : undefined;
      })();

      // Hedef DB listesi (test DB'leri hariç)
      const TARGET_DBS_LOCAL = ['V3_StDeri', 'V3_StDeriLTD', 'V3_SerkanCanta', 'V3_SerkanCantaLTD'];

      // Satış temsilcisi kodları: bölgeye göre default, modal seçimleri varsa override
      const perDbSalespersonCodes: Record<string, string> = {
        V3_StDeri: (perDbSelections.stDeri.salesperson || regionSalesman || '') as string,
        V3_StDeriLTD: (perDbSelections.stDeri.salesperson || regionSalesman || '') as string,
        V3_SerkanCanta: (perDbSelections.serkanCanta.salesperson || '') as string,
        V3_SerkanCantaLTD: (perDbSelections.serkanCanta.salesperson || '') as string,
      };

      // Per-DB Fiyat Grubu ve İskonto Grubu sözlükleri (modal seçimleri öncelikli)
      const perDbWholesalePriceGroupCode: Record<string, string> = {
        V3_StDeri: (perDbSelections.stDeri.priceGroup || selectedWholesalePriceGroupCode || '') as string,
        V3_StDeriLTD: (perDbSelections.stDeri.priceGroup || selectedWholesalePriceGroupCode || '') as string,
        V3_SerkanCanta: (perDbSelections.serkanCanta.priceGroup || selectedWholesalePriceGroupCode || '') as string,
        V3_SerkanCantaLTD: (perDbSelections.serkanCanta.priceGroup || selectedWholesalePriceGroupCode || '') as string,
      };

      const perDbDiscountGroupCode: Record<string, string> = {
        V3_StDeri: (perDbSelections.stDeri.discountGroup || selectedDiscountGroupCode || '') as string,
        V3_StDeriLTD: (perDbSelections.stDeri.discountGroup || selectedDiscountGroupCode || '') as string,
        V3_SerkanCanta: (perDbSelections.serkanCanta.discountGroup || selectedDiscountGroupCode || '') as string,
        V3_SerkanCantaLTD: (perDbSelections.serkanCanta.discountGroup || selectedDiscountGroupCode || '') as string,
      };

      // Per-DB müşteri özellikleri (Fatura Şekli - her durumda gönder, defaultlarla doldur)
      const perDbCustomerProperties: Record<string, Record<number, string>> = {};
      const invTypeCodeSubmit = invoiceTypeTypeCode || 1; // typeCode bulunamazsa 1'e düş
      const stInvSubmit = perDbSelections.stDeri.invoiceType || '10'; // seçilmediyse '10' (Tam Fatura)
      const scInvSubmit = perDbSelections.serkanCanta.invoiceType || '10';
      perDbCustomerProperties['V3_StDeri'] = { [invTypeCodeSubmit]: stInvSubmit };
      perDbCustomerProperties['V3_StDeriLTD'] = { [invTypeCodeSubmit]: stInvSubmit };
      perDbCustomerProperties['V3_SerkanCanta'] = { [invTypeCodeSubmit]: scInvSubmit };
      perDbCustomerProperties['V3_SerkanCantaLTD'] = { [invTypeCodeSubmit]: scInvSubmit };

      // Vergi dairesi kodunu güvene al: eğer formda ad varsa koda çevir
      const taxOfficeCodeFinal = (() => {
        const val = (formData.taxOffice || '').trim();
        const list = taxOfficesDataFromHook || [];
        if (!val || list.length === 0) return val;
        const isValidCode = list.some((o: any) => String(o.taxOfficeCode) === val);
        if (isValidCode) return val;
        const code = resolveTaxOfficeCode(val, list as any[]);
        return code || val;
      })();

      // Detaylı mod için ek alanlar
      if (formData.formType === 'detailed') {
        if (formData.isIndividual) {
          // Bireysel müşteri için TC kimlik numarası - varsayılan değer kullan
          customerData.identityNum = identityNumToUse;
        }
        // Vergi bilgileri
        if (formData.taxNumber) {
          customerData.taxNumber = formData.taxNumber;
          customerData.taxOfficeCode = taxOfficeCodeFinal; 
        }
      }
      
      // Vergi bilgilerini her durumda ekle
      customerData.taxNumber = formData.taxNumber || "";
      customerData.taxOfficeCode = taxOfficeCodeFinal || "";

      // Kullanıcı adını al
      const userName = localStorage.getItem('userName') || 'system';
      
      // Benzersiz adres ID'si oluştur
      const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };
      
      console.log('E-Fatura durumu:', formData.isSubjectToEInvoice, 'E-Fatura başlangıç tarihi:', formData.eInvoiceStartDate);
      console.log('E-İrsaliye durumu:', formData.isSubjectToEDispatch, 'E-İrsaliye başlangıç tarihi:', formData.eDispatchStartDate);
      console.log('Gönderilecek müşteri verisi:', customerData);
      
      // Ortak Müşteri Özellikleri: varsayılanlar + modal seçimleri (request'e dahil edilecek)
      const customerPropertiesForRequest: Record<number, string> = (() => {
        const hasDefaults = DEFAULT_CUSTOMER_PROPERTIES && Object.keys(DEFAULT_CUSTOMER_PROPERTIES).length > 0;
        const hasSelected = selectedCustomerProperties && Object.keys(selectedCustomerProperties).length > 0;
        const merged: Record<number, string> = { ...(hasDefaults ? DEFAULT_CUSTOMER_PROPERTIES : ({} as Record<number, string>)) };
        if (hasSelected) {
          Object.entries(selectedCustomerProperties).forEach(([k, v]) => {
            const nk = parseInt(k, 10);
            if (!Number.isNaN(nk)) merged[nk] = v.toString();
          });
        }
        return merged;
      })();

      // 1. Adım: Atomik gönderim için Adresler, İletişimler ve Kişiler dizilerini hazırla
      // Adresler (Billing ve gerekirse Shipping)
      let addressToUse = formData.address;
      let stateCodeToUse = formData.region;
      let cityCodeToUse = formData.city;
      let districtCodeToUse = formData.district;

      // Adres girilmemişse ve Türkiye seçiliyse varsayılan değerleri kullan
      if ((!formData.address || formData.address.trim() === '') && formData.country === 'TR') {
        addressToUse = 'İstanbul, Osmanbey 1';
        stateCodeToUse = 'TR.MR';
        cityCodeToUse = 'TR.34';
        districtCodeToUse = 'TR.03412';
      }

      const addressesPayload: any[] = [];
      if (addressToUse && addressToUse.trim() !== '') {
        // Fatura Adresi (legacy code: 3)
        addressesPayload.push({
          AddressTypeCode: '3',
          Address: addressToUse || '',
          CountryCode: 'TR',
          StateCode: stateCodeToUse,
          CityCode: cityCodeToUse,
          DistrictCode: districtCodeToUse || '',
          TaxOffice: '',
          TaxOfficeCode: taxOfficeCodeFinal || '',
          TaxNumber: formData.taxNumber || '',
          AddressID: 0,
          IsBlocked: false,
          IsDefault: true,
          IsBillingAddress: true,
          IsShippingAddress: false,
          CreatedUserName: user?.userName || 'SYSTEM',
          LastUpdatedUserName: user?.userName || 'SYSTEM'
        });

        if (formData.isShippingSameAsBilling) {
          // Sevkiyat Adresi (legacy code: 5) - fatura adresi ile aynı
          addressesPayload.push({
            AddressTypeCode: '5',
            Address: addressToUse || '',
            CountryCode: 'TR',
            StateCode: stateCodeToUse,
            CityCode: cityCodeToUse,
            DistrictCode: districtCodeToUse || '',
            TaxOffice: '',
            TaxOfficeCode: taxOfficeCodeFinal || '',
            TaxNumber: formData.taxNumber || '',
            AddressID: 0,
            IsBlocked: false,
            IsDefault: true,
            IsBillingAddress: false,
            IsShippingAddress: true,
            CreatedUserName: user?.userName || 'SYSTEM',
            LastUpdatedUserName: user?.userName || 'SYSTEM'
          });
        }
      }

      if (!formData.isShippingSameAsBilling) {
        const shipAddress = formData.shippingAddress && formData.shippingAddress.trim() !== '' ? formData.shippingAddress : addressToUse;
        const shipState = formData.shippingRegion || stateCodeToUse;
        const shipCity = formData.shippingCity || cityCodeToUse;
        const shipDistrict = formData.shippingDistrict || districtCodeToUse;
        if (shipAddress && shipAddress.trim() !== '') {
          addressesPayload.push({
            AddressTypeCode: '5',
            Address: shipAddress || '',
            CountryCode: 'TR',
            StateCode: shipState,
            CityCode: shipCity,
            DistrictCode: shipDistrict || '',
            TaxOffice: '',
            TaxOfficeCode: taxOfficeCodeFinal || '',
            TaxNumber: formData.taxNumber || '',
            AddressID: 0,
            IsBlocked: false,
            IsDefault: true,
            IsBillingAddress: false,
            IsShippingAddress: true,
            CreatedUserName: user?.userName || 'SYSTEM',
            LastUpdatedUserName: user?.userName || 'SYSTEM'
          });
        }
      }

      // İletişimler (Telefon ve E-posta)
      const communicationsPayload: any[] = [];
      if (formData.authPhone && formData.authPhone.trim() !== '') {
        communicationsPayload.push({ CommunicationTypeCode: '6', CommAddress: formData.authPhone.trim(), IsDefault: true, CreatedUserName: user?.userName || 'SYSTEM', LastUpdatedUserName: user?.userName || 'SYSTEM' });
      }
      if (formData.accountingPhone && formData.accountingPhone.trim() !== '') {
        communicationsPayload.push({ CommunicationTypeCode: '15', CommAddress: formData.accountingPhone.trim(), IsDefault: false, CreatedUserName: user?.userName || 'SYSTEM', LastUpdatedUserName: user?.userName || 'SYSTEM' });
      }
      if (formData.authEmail && formData.authEmail.trim() !== '') {
        communicationsPayload.push({ CommunicationTypeCode: '3', CommAddress: formData.authEmail.trim(), IsDefault: true, CreatedUserName: user?.userName || 'SYSTEM', LastUpdatedUserName: user?.userName || 'SYSTEM' });
      }
      if (formData.accountingEmail && formData.accountingEmail.trim() !== '') {
        communicationsPayload.push({ CommunicationTypeCode: '14', CommAddress: formData.accountingEmail.trim(), IsDefault: false, CreatedUserName: user?.userName || 'SYSTEM', LastUpdatedUserName: user?.userName || 'SYSTEM' });
      }

      // Kişiler (Varsa)
      const contactsPayload: any[] = [];
      if (formData.firstName && formData.lastName) {
        const contactObj: any = {
          FirstName: formData.firstName,
          LastName: formData.lastName,
          IsDefault: true,
          CreatedUserName: user?.userName || 'SYSTEM',
          LastUpdatedUserName: user?.userName || 'SYSTEM'
        };
        if (formData.identityNum) {
          contactObj.IdentityNum = formData.identityNum;
        }
        contactsPayload.push(contactObj);
      }

      // 2. Adım: Temel + ek tüm bilgileri tek atomik çağrıda gönder
      console.log('Seçilen Fiyat Grubu (UI state):', selectedWholesalePriceGroupCode);
      console.log('Seçilen İskonto Grubu (UI state):', selectedDiscountGroupCode);
      // Güvenlik ağı: Genel CustomerProperties içine de Fatura Şekli defaultunu ekle (Per-DB önceliklidir)
      try {
        const invTypeCodeGeneral = invoiceTypeTypeCode || 1;
        if (!customerPropertiesForRequest[invTypeCodeGeneral]) {
          customerPropertiesForRequest[invTypeCodeGeneral] = '10';
        }
      } catch { /* ignore */ }
      const customerResponse = await customerApi.createCustomerBasic({
        ...customerData,
        // Seçim varsa gönder; yoksa api.ts içindeki resolveLookupDefaults devreye girer
        wholesalePriceGroupCode: selectedWholesalePriceGroupCode,
        discountGroupCode: selectedDiscountGroupCode,
        // Satış temsilcisi ve per-DB alanlar
        SalespersonCode: (regionSalesman || '') as string,
        PerDbSalespersonCodes: perDbSalespersonCodes,
        PerDbCustomerProperties: perDbCustomerProperties,
        PerDbWholesalePriceGroupCode: perDbWholesalePriceGroupCode,
        PerDbDiscountGroupCode: perDbDiscountGroupCode,
        CustomerProperties: customerPropertiesForRequest,
        // Atomik ek alanlar
        Addresses: addressesPayload,
        Communications: communicationsPayload,
        Contacts: contactsPayload,
        // Alt müşteriler
        SubCustomers: Array.isArray(subCustomers) && subCustomers.length > 0 ? subCustomers : undefined,
        // Hedef veritabanları
        targetDatabases: selectedTargetDbs
      }, { requestId });
      
      if (customerResponse.success) {
        // Müşteri başarıyla oluşturuldu
        // Başarı durumunda konfeti ve ses efekti
        setShowConfetti(true);
        playSuccessSound();
        
        // 5 saniye sonra konfeti efektini kaldır
        setTimeout(() => setShowConfetti(false), 5000);
        
        // Normal müşteri oluşturma akışında token kullanılmaz
        // QR code akışında token kullanılır
        console.log('Normal müşteri oluşturma akışı: Token kullanılmadan devam ediliyor');
        
        // Tek çağrı ile tüm bilgiler gönderildi; bildirimleri göster
        let bildirimMesaji = 'Müşteri başarıyla oluşturuldu ve tüm bilgiler kaydedildi';
        let bildirimTipi: 'success' | 'error' = 'success';

        setSnackbar({
          open: true,
          message: bildirimMesaji,
          severity: bildirimTipi
        });
        setBackendAlert({
          open: true,
          asModal: false,
          severity: bildirimTipi,
          title: 'Başarılı',
          message: bildirimMesaji
        });

        // Formu sıfırla ve yönlendir
        resetForm();
        const targetAfterCreate = user?.roles?.includes('ss') ? '/sales-menu' : '/';
        setTimeout(() => {
          navigate(targetAfterCreate);
        }, 2500);
      } else {
        errorMessage = customerResponse.message || 'Müşteri oluşturulurken bir hata oluştu!';
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
        setBackendAlert({
          open: true,
          asModal: true,
          severity: 'error',
          title: 'Müşteri Oluşturma Hatası',
          message: errorMessage
        });
        
        // Hata durumunda ses efekti
        playErrorSound();
      }
    } catch (error: any) {
      console.error("Müşteri oluşturulurken hata oluştu:", error);
      const msg2 = error.response?.data?.message || error.message || 'Müşteri oluşturulurken bir hata oluştu!';
      setSnackbar({
        open: true,
        message: msg2,
        severity: 'error'
      });
      setBackendAlert({
        open: true,
        asModal: true,
        severity: 'error',
        title: 'Müşteri Oluşturma Hatası',
        message: msg2
      });
      
      // Hata durumunda ses efekti
      playErrorSound();
    } finally {
      setIsLoading(false);
    }
  };

  // Global UI ayarları yüklenene kadar hiçbir içerik gösterme (flash engelleme)
  if (!uiSettingsLoaded) {
    return null;
  }

  return (
    <Box sx={{ pb: isMobile ? '80px' : 0 }}>
    <Container maxWidth="md" disableGutters sx={{ 
      py: 4,
      px: isMobile ? 1 : 3
    }}>
      {showConfetti && (
        <ReactConfetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          recycle={false}
          numberOfPieces={500}
          gravity={0.2}
        />
      )}
      <Paper elevation={3} sx={{ p: 3, mt: 3, mb: isMobile ? 10 : 3 }}>
        {/* Panel Header */}
        <Box sx={{ mb: 2, bgcolor: 'primary.main', color: 'primary.contrastText', textAlign: 'center', py: 1.5, borderRadius: 1 }}>
          <Typography variant="h6" sx={{ m: 0, letterSpacing: 0.5, fontWeight: 600 }}>MÜŞTERİ KAYIT FORMU</Typography>
        </Box>

        {/* Benzer müşteri uyarısı */}
        {dupeOpen && dupeResults && dupeResults.length > 0 && (
          <Alert
            severity="warning"
            onClose={() => setDupeOpen(false)}
            sx={{ mb: 2 }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
              Benzer kayıtlar bulundu. Lütfen mükerrer kayıt oluşturmamaya dikkat edin.
            </Typography>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              {(dupeResults.slice(0, 5) as any[]).map((it: any, idx: number) => {
                const code = it.customerCode || it.CustomerCode || '-';
                const name = it.customerName || it.CustomerName || '-';
                const tax = it.taxNumber || it.TaxNumber || '';
                const tc = it.identityNum || it.IdentityNum || '';
                return (
                  <Box component="li" key={idx} sx={{ listStyle: 'disc' }}>
                    <Typography variant="body2">
                      {code} - {name}
                      {tax ? ` | VKN: ${tax}` : ''}
                      {tc ? ` | TCKN: ${tc}` : ''}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Alert>
        )}

        {/* Çoklu-DB mükerrer uyarısı */}
        {multiDupOpen && multiDupResults && multiDupResults.length > 0 && (
          <Alert
            severity="warning"
            onClose={() => setMultiDupOpen(false)}
            sx={{ mb: 2 }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
              Çoklu veritabanında eşleşen kayıtlar bulundu (STD/STL/SCT/SCL).
            </Typography>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              {(multiDupResults.slice(0, 8) as any[]).map((it: any, idx: number) => {
                const code = it.CustomerCode || it.customerCode || '-';
                const name = it.CustomerName || it.customerName || '-';
                const tax = it.TaxNumber || it.taxNumber || '';
                const tc = it.IdentityNum || it.identityNum || '';
                const db = it.SourceDb || it.sourceDb || '';
                return (
                  <Box component="li" key={idx} sx={{ listStyle: 'disc' }}>
                    <Typography variant="body2">
                      [{db}] {code} - {name}
                      {tax ? ` | VKN: ${tax}` : ''}
                      {tc ? ` | TCKN: ${tc}` : ''}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Alert>
        )}

        

        {/* Kayıt işlemi sırasında kullanıcı etkileşimini engelleyen overlay */}
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1, display: 'flex', flexDirection: 'column', gap: 2 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
          <Typography variant="subtitle1">Müşteri kayıt işlemi devam ediyor...</Typography>
        </Backdrop>
        <Box component="form" noValidate sx={{ mt: 2 }} onSubmit={handleSubmit} className="customer-form">
          {/* Form tipi artık sadece 'detailed' olarak sabit - RadioGroup kaldırıldı */}
          
          {/* Üst yerleşim: 1. satır solda DB checkbox'ları, sağda Görselden Getir; 2. satır tam genişlik Ünvan */}
          <Box className="form-row" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
              {/* Sol: DB checkbox grubu (başlık yazma) */}
              {uiShowDbSelection && (
              <FormGroup row sx={{ flex: '1 1 auto' }}>
                {TARGET_DBS.map(db => {
                  const checked = selectedTargetDbs.includes(db);
                  const isLastOfGroupStd = GROUP_STD.has(db) && db === 'V3_StDeriLTD';
                  return (
                    <FormControlLabel
                      key={db}
                      sx={{ mr: isLastOfGroupStd ? 3 : 1 }}
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={() => toggleTargetDb(db)}
                        />
                      }
                      label={renderDbLabelChip(db, checked)}
                    />
                  );
                })}
              </FormGroup>
              )}

              {/* Sağ: Görselden Getir */}
              {uiShowOcrButton && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleOcrFileSelected}
                    style={{ display: 'none' }}
                  />
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleOcrBrowse}
                    disabled={isOcrLoading}
                  >
                    {isOcrLoading ? 'OCR Çalışıyor...' : 'Görselden Getir'}
                  </Button>
                </Box>
              )}
            </Box>

            <TextField
              fullWidth
              required
              label="Müşteri Ünvanı"
              name="customerName"
              className="full-row phone-field"
              value={formData.customerName}
              onChange={handleInputChange}
              placeholder="Müşteri Ünvanı"
              sx={{ width: '100% !important', flex: '0 0 100% !important', maxWidth: '100% !important' }}
            />
          </Box>

          {formData.formType === 'detailed' && (
            <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mb: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isIndividual}
                    onChange={handleCheckboxChange}
                    name="isIndividual"
                  />
                }
                label="Gerçek Kişi/Şahıs"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.isSubjectToEInvoice}
                    onChange={handleCheckboxChange}
                    name="isSubjectToEInvoice"
                  />
                }
                label="E-fatura Tabi"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.isSubjectToEDispatch}
                    onChange={handleCheckboxChange}
                    name="isSubjectToEDispatch"
                  />
                }
                label="E-İrsaliye Tabi"
              />
            </Box>
          )}

          {/* E-fatura/E-İrsaliye tarih alanları (opsiyonel) */}
          {(formData.isSubjectToEInvoice || formData.isSubjectToEDispatch) && (
            <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
              {formData.isSubjectToEInvoice && (
                <TextField
                  type="date"
                  label="E-fatura Başlangıç Tarihi"
                  value={formData.eInvoiceStartDate ? formData.eInvoiceStartDate.toISOString().split('T')[0] : ''}
                  onChange={(e) => handleDateChange('eInvoiceStartDate', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  sx={{ flex: '1 1 45%', minWidth: '200px' }}
                />
              )}
              {formData.isSubjectToEDispatch && (
                <TextField
                  type="date"
                  label="E-İrsaliye Başlangıç Tarihi"
                  value={formData.eDispatchStartDate ? formData.eDispatchStartDate.toISOString().split('T')[0] : ''}
                  onChange={(e) => handleDateChange('eDispatchStartDate', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  sx={{ flex: '1 1 45%', minWidth: '200px' }}
                />
              )}
            </Box>
          )}
          

          {formData.formType === 'detailed' && formData.isIndividual && (
            <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                required
                label="Ad"
                name="firstName"
                value={formData.firstName}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setFormData(prev => {
                    // Ad alanı değiştiğinde, müşteri ünvanını güncelle
                    const updatedData = { ...prev, firstName: newValue };
                    if (prev.lastName) {
                      updatedData.customerName = `${newValue} ${prev.lastName}`;
                    } else {
                      updatedData.customerName = newValue;
                    }
                    return updatedData;
                  });
                }}
                sx={{ flex: '1 1 45%', minWidth: '200px' }}
              />
              <TextField
                fullWidth
                required
                label="Soyad"
                name="lastName"
                value={formData.lastName}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setFormData(prev => {
                    // Soyad alanı değiştiğinde, müşteri ünvanını güncelle
                    const updatedData = { ...prev, lastName: newValue };
                    if (prev.firstName) {
                      updatedData.customerName = `${prev.firstName} ${newValue}`;
                    } else {
                      updatedData.customerName = newValue;
                    }
                    return updatedData;
                  });
                }}
                sx={{ flex: '1 1 45%', minWidth: '200px' }}
              />
              <TextField
                fullWidth
                required
                label="T.C. Kimlik No"
                name="identityNum"
                value={formData.identityNum}
                onChange={handleInputChange}
                placeholder="12345678901"
                InputProps={{
                  endAdornment: (formData.isSubjectToEInvoice || formData.isSubjectToEDispatch) ? (
                    <InputAdornment position="end">
                      <CheckCircleIcon color="success" />
                    </InputAdornment>
                  ) : undefined
                }}
                sx={{ flex: '1 1 100%', minWidth: '200px' }}
              />

            </Box>
          )}

          {formData.formType === 'detailed' && !formData.isIndividual && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
              {formData.taxOffice ? (
                // Vergi dairesi seçilmişse, kod ve adı göster
                <Box sx={{ flex: '1 1 45%', minWidth: '200px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <TextField
                    fullWidth
                    label="Vergi Dairesi Kodu"
                    value={formData.taxOffice}
                    disabled
                    helperText="Seçildi"
                  />
                  <TextField
                    fullWidth
                    label="Vergi Dairesi Adı"
                    value={taxOfficesDataFromHook?.find(office => office.taxOfficeCode === formData.taxOffice)?.taxOfficeDescription || ''}
                    disabled
                  />
                  <Button 
                    size="small" 
                    color="primary" 
                    onClick={() => setFormData({...formData, taxOffice: ''})}
                    sx={{ alignSelf: 'flex-start' }}
                  >
                    Değiştir
                  </Button>
                </Box>
              ) : (
                // Vergi dairesi seçilmemişse, seçim listesini göster
                <FormControl fullWidth required sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                  <InputLabel>Vergi Dairesi</InputLabel>
                  <Select
                    name="taxOffice"
                    value={formData.taxOffice || ''}
                    label="Vergi Dairesi"
                    onChange={handleSelectChange}
                    disabled={isLoadingTaxOfficesHook}
                  >
                    {isLoadingTaxOfficesHook ? (
                      <MenuItem value="" disabled>Yükleniyor...</MenuItem>
                    ) : taxOfficesDataFromHook && taxOfficesDataFromHook.length > 0 ? (
                      taxOfficesDataFromHook.map((office: any) => (
                        <MenuItem key={office.taxOfficeCode} value={office.taxOfficeCode}>
                          {office.taxOfficeDescription || office.taxOfficeCode}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>Vergi dairesi bulunamadı</MenuItem>
                    )}
                  </Select>
                </FormControl>
              )}
              <TextField
                fullWidth
                required
                label="Vergi No"
                name="taxNumber"
                value={formData.taxNumber}
                onChange={handleInputChange}
                InputProps={{
                  endAdornment: (formData.isSubjectToEInvoice || formData.isSubjectToEDispatch) ? (
                    <InputAdornment position="end">
                      <CheckCircleIcon color="success" />
                    </InputAdornment>
                  ) : undefined
                }}
                sx={{ flex: '1 1 45%', minWidth: '200px' }}
              />
              
            </Box>
          )}

          

          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Sol blok: Fatura Adresi + Müşteri Özellikleri butonu */}
            <Box sx={{ width: '100%' }}>
              <Typography variant="subtitle1" gutterBottom>Adres Bilgileri (Fatura Adresi)</Typography>
              <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                <FormControl fullWidth required sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                  <InputLabel>Ülke</InputLabel>
                  <Select
                    name="country"
                    value={formData.country || ''}
                    label="Ülke"
                    onChange={handleSelectChange}
                  >
                    {countries.length > 0 ? (
                      countries.map(c => (
                        <MenuItem key={c.countryCode} value={c.countryCode}>
                          {c.countryDescription}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="TR">Türkiye</MenuItem>
                    )}
                  </Select>
                </FormControl>
                {formData.country === 'TR' && (
                  <>
                    <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                      <InputLabel>Bölge</InputLabel>
                      <Select
                        name="region"
                        value={formData.region || ''}
                        label="Bölge"
                        onChange={handleSelectChange}
                      >
                        {regions.map(r => (
                          <MenuItem key={r.code} value={r.code}>{r.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                      <InputLabel>Şehir</InputLabel>
                      <Select
                        name="city"
                        value={formData.city || ''}
                        label="Şehir"
                        onChange={handleSelectChange}
                      >
                        {cities.map(c => (
                          <MenuItem key={c.code} value={c.code}>{c.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                      <InputLabel>İlçe</InputLabel>
                      <Select
                        name="district"
                        value={formData.district || ''}
                        label="İlçe"
                        onChange={handleSelectChange}
                      >
                        {districts.map(d => (
                          <MenuItem key={d.code} value={d.code}>{d.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </>
                )}
                <TextField
                  fullWidth
                  label="Adres"
                  name="address"
                  className="full-row"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="İstanbul, Osmanbey 1"
                  multiline
                  rows={2}
                  sx={{ flex: '1 1 100%' }}
                />
              </Box>
            
              <Box sx={{ mb: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.isShippingSameAsBilling}
                      onChange={(e) => setFormData(prev => ({ ...prev, isShippingSameAsBilling: e.target.checked }))}
                      name="isShippingSameAsBilling"
                    />
                  }
                  label="Teslim Adresi (Fatura Adresi ile aynı)"
                />
              </Box>
              {!formData.isShippingSameAsBilling && (
                <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                    <InputLabel>Bölge</InputLabel>
                    <Select
                      name="shippingRegion"
                      value={formData.shippingRegion || ''}
                      label="Bölge"
                      onChange={handleSelectChange}
                    >
                      {regions.map(r => (
                        <MenuItem key={r.code} value={r.code}>{r.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                    <InputLabel>Şehir</InputLabel>
                    <Select
                      name="shippingCity"
                      value={formData.shippingCity || ''}
                      label="Şehir"
                      onChange={handleSelectChange}
                    >
                      {shippingCities.map(c => (
                        <MenuItem key={c.code} value={c.code}>{c.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                    <InputLabel>İlçe</InputLabel>
                    <Select
                      name="shippingDistrict"
                      value={formData.shippingDistrict || ''}
                      label="İlçe"
                      onChange={handleSelectChange}
                    >
                      {shippingDistricts.map(d => (
                        <MenuItem key={d.code} value={d.code}>{d.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Adres"
                    name="shippingAddress"
                    className="full-row"
                    value={formData.shippingAddress}
                    onChange={handleInputChange}
                    placeholder="İstanbul, Osmanbey 1"
                    multiline
                    rows={2}
                    sx={{ flex: '1 1 100%' }}
                  />
                </Box>
              )}
            </Box>
          </Box>

          {/* (Üstte taşındı) */}

          {/* Para Birimi Seçimi + Müşteri Özellikleri Butonu */}
          <Box className="form-row" sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mt: 2, mb: 3 }}>
            <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: '200px' }}>
              <InputLabel>Para Birimi</InputLabel>
              <Select
                name="exchangeTypeCode"
                value={(isLoadingCurrenciesHook || !currenciesDataFromHook || currenciesDataFromHook.length === 0) ? '' : formData.exchangeTypeCode}
                label="Para Birimi"
                onChange={handleSelectChange}
                disabled={isLoadingCurrenciesHook}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300
                    },
                  },
                }}
              >
                {isLoadingCurrenciesHook ? (
                  <MenuItem value="" disabled>Yükleniyor...</MenuItem>
                ) : currenciesDataFromHook && currenciesDataFromHook.length > 0 ? (
                  currenciesDataFromHook.map((currency: any) => (
                    <MenuItem key={currency.currencyCode} value={currency.currencyCode}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span><strong>{currency.currencyCode}</strong> - {currency.currencyDescription}</span>
                      </Box>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>Para birimi bulunamadı</MenuItem>
                )}
              </Select>
            </FormControl>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => (formData.region || (formData as any).stateCode) && setIsCustomerPropertiesModalOpen(true)}
              disabled={!(formData.region || (formData as any).stateCode)}
              title={(formData.region || (formData as any).stateCode) ? '' : 'Önce bölge seçiniz. ST DERİ temsilcisi bölgeye göre varsayılan gelir.'}
            >
              Müşteri Özellikleri
            </Button>
            {uiShowSubCustomerButton && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setIsSubCustomersModalOpen(true)}
                title="Alt müşteri (prSubCurrAcc) kayıtları ekleyin/düzenleyin"
              >
                Alt Müşteriler{(subCustomers && subCustomers.length > 0) ? ` (${subCustomers.length})` : ''}
              </Button>
            )}
            
          </Box>

          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" gutterBottom>İletişim Bilgileri</Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
            <TextField
              fullWidth
              required
              label="Yetkili Kişi Telefonu"
              name="authPhone"
              value={formData.authPhone}
              onChange={handleInputChange}
              placeholder="90-5xx-xxx-xx-xx"
              sx={{ flex: '1 1 45%', minWidth: '200px' }}
            />
            <TextField
              fullWidth
              required
              label="Yetkili Kişi E-Posta"
              name="authEmail"
              type="email"
              value={formData.authEmail}
              onChange={handleInputChange}
              placeholder="yetkili@firma.com"
              sx={{ flex: '1 1 45%', minWidth: '200px' }}
            />
            <TextField
              fullWidth
              label="Muhasebe Sabit Telefon"
              name="accountingPhone"
              value={formData.accountingPhone}
              onChange={handleInputChange}
              placeholder="0xxx xxx xx xx"
              sx={{ flex: '1 1 45%', minWidth: '200px' }}
            />
            <TextField
              fullWidth
              label="Muhasebe E-Posta"
              name="accountingEmail"
              type="email"
              value={formData.accountingEmail}
              onChange={handleInputChange}
              placeholder="muhasebe@firma.com"
              sx={{ flex: '1 1 45%', minWidth: '200px' }}
            />
          </Box>


          {/* Mobil cihazlarda boşluk bırakıyoruz ki sabit butonlar ve alt menü içeriği kapatmasın */}
          {isMobile && <Box sx={{ height: '180px' }} />}
          
          {/* Masaüstü için normal butonlar */}
          {!isMobile && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                type="button"
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={() => navigate('/customers')}
              >
                İptal
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading || selectedTargetDbs.length === 0}
              >
                {isLoading ? <CircularProgress size={24} /> : 'Kaydet'}
              </Button>
            </Box>
          )}

          {/* Mobil için sabit aksiyon çubuğu */}
          {isMobile && (
            <Paper
              elevation={6}
              sx={{
                position: 'fixed',
                left: 0,
                right: 0,
                // Alt mobil menünün (8px üst padding + 64px grid yüksekliği + 10px alt padding) toplam yüksekliğini ve güvenli alanı hesaba kat
                bottom: `calc(82px + env(safe-area-inset-bottom, 0px))`,
                // Mobil alt menü zIndex: 9999, bunun üstünde tutalım
                zIndex: 10050,
                p: 1.5,
                mx: 'auto',
                maxWidth: 'md',
                backgroundColor: 'background.paper',
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
              }}
            >
              <Box sx={{ display: 'flex', gap: 1.5 }}>
                <Button
                  type="button"
                  variant="outlined"
                  fullWidth
                  onClick={() => navigate('/customers')}
                >
                  İptal
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={isLoading || selectedTargetDbs.length === 0}
                >
                  {isLoading ? <CircularProgress size={24} /> : 'Kaydet'}
                </Button>
              </Box>
            </Paper>
          )}
          
          
        </Box>
      </Paper>
      {replicationVisible && (
        <Paper sx={{ mt: 3, p: 2, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h6" gutterBottom>
            Çoklu-DB İlerleme
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            {(selectedTargetDbs || []).map(db => {
              const st = replicationStatuses[db] || { status: 'pending' };
              const color = st.status === 'success' ? 'success.main' : st.status === 'error' ? 'error.main' : st.status === 'in_progress' ? 'warning.main' : 'text.secondary';
              const label = st.status === 'success' ? 'Tamamlandı' : st.status === 'error' ? 'Hata' : st.status === 'in_progress' ? 'Devam ediyor' : 'Beklemede';
              return (
                <Box key={db} sx={{ display: 'flex', alignItems: 'center', border: '1px dashed', borderColor: 'divider', borderRadius: 1, px: 1.5, py: 1 }}>
                  <Typography sx={{ fontWeight: 600, mr: 1 }}>{db}</Typography>
                  <Typography sx={{ color }}>{label}</Typography>
                  {st.message && (
                    <Typography sx={{ ml: 1, color: 'text.secondary' }}>– {st.message}</Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        </Paper>
      )}


      {/* Backend üst bant uyarısı (mobil uyumlu) */}
      {backendAlert.open && !backendAlert.asModal && (
        <Box sx={{ position: { xs: 'fixed', sm: 'fixed' }, top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.snackbar + 1, p: { xs: 1, sm: 2 } }}>
          <Alert
            severity={backendAlert.severity}
            onClose={handleCloseBackendAlert}
            action={
              <Button color="inherit" size="small" onClick={handleCloseBackendAlert} startIcon={<CloseIcon fontSize="small" />}>Kapat</Button>
            }
            sx={{
              mx: 'auto',
              maxWidth: 800,
              boxShadow: 3,
              borderRadius: 2,
            }}
          >
            <Box>
              {backendAlert.title && (
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
                  {backendAlert.title}
                </Typography>
              )}
              <Typography variant="body2">{backendAlert.message}</Typography>
            </Box>
          </Alert>
        </Box>
      )}

      {/* Backend modal uyarısı */}
      <Dialog
        open={!!backendAlert.open && !!backendAlert.asModal}
        onClose={handleCloseBackendAlert}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={backendAlert.severity === 'error' ? 'Hata' : backendAlert.severity === 'success' ? 'Başarılı' : backendAlert.severity === 'warning' ? 'Uyarı' : 'Bilgi'}
              color={backendAlert.severity === 'error' ? 'error' : backendAlert.severity === 'success' ? 'success' : backendAlert.severity === 'warning' ? 'warning' : 'info'}
              size="small"
            />
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {backendAlert.title || 'İşlem Bildirimi'}
            </Typography>
          </Box>
          <Button onClick={handleCloseBackendAlert} size="small" startIcon={<CloseIcon />}>Kapat</Button>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">{backendAlert.message}</Typography>
          {replicationVisible && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" gutterBottom>Çoklu-DB Durum Özeti</Typography>
              <Stack direction="column" spacing={1}>
                {TARGET_DBS.map(db => {
                  if (!selectedTargetDbs.includes(db)) return null;
                  const st = replicationStatuses[db] || { status: 'pending' };
                  const color = st.status === 'success' ? 'success' : st.status === 'error' ? 'error' : st.status === 'in_progress' ? 'warning' : 'default';
                  const label = st.status === 'success' ? 'Tamamlandı' : st.status === 'error' ? 'Hata' : st.status === 'in_progress' ? 'Devam ediyor' : 'Beklemede';
                  return (
                    <Stack key={db} direction="row" spacing={1} alignItems="center">
                      <Chip label={db} variant="outlined" />
                      <Chip label={label} color={color as any} size="small" />
                      {st.message && <Typography variant="caption" color="text.secondary">{st.message}</Typography>}
                    </Stack>
                  );
                })}
              </Stack>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBackendAlert} variant="contained">Tamam</Button>
        </DialogActions>
      </Dialog>

      {/* OCR Önizleme Modalı */}
      <Dialog open={ocrModalOpen} onClose={handleCloseOcrModal} fullWidth maxWidth="sm">
        <DialogTitle>OCR Önizleme</DialogTitle>
        <DialogContent dividers>
          {/* Görsel Önizleme ve Tarama Efekti */}
          {ocrImageUrl && (
            <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', mb: 2, boxShadow: 3 }}>
              {/* Görsel (parmak izi yerine gerçek görüntü) */}
              <Box component="img" src={ocrImageUrl} alt="OCR Görseli" sx={{ width: '100%', display: 'block' }} />

              {isOcrLoading && (
                <>
                  {/* Dış çerçeve (beyaz) */}
                  <Box sx={{ position: 'absolute', inset: 8, border: '6px solid #fff', borderRadius: 2, pointerEvents: 'none' }} />

                  {/* Tarama çubuğu (camgöbeği) */}
                  <Box sx={{
                    position: 'absolute', left: '10%', right: '10%', top: 0, height: 8,
                    backgroundColor: '#2beeee', borderRadius: 8,
                    filter: 'drop-shadow(0 0 20px #2beeee) drop-shadow(0 0 60px #2beeee)',
                    animation: `${animationBar} 4s ease-in-out infinite`,
                  }} />

                  {/* Yumuşak tarama alanı (üstten alta) */}
                  <Box sx={{
                    position: 'absolute', left: 0, right: 0, top: 0, height: '85%',
                    background: 'linear-gradient(to bottom, rgba(43,238,238,0.05), rgba(43,238,238,0.15), rgba(43,238,238,0.05))',
                    animation: `${scanAnim} 4s ease-in-out infinite`,
                    pointerEvents: 'none'
                  }} />

                  {/* Mesaj: Taranıyor + nokta animasyonu */}
                  <Box sx={{
                    position: 'absolute', left: '50%', transform: 'translateX(-50%)', bottom: -30,
                    color: '#2beeee', fontSize: 22, letterSpacing: '5px', textTransform: 'uppercase',
                    fontFamily: 'monospace', display: 'inline-flex', alignItems: 'center',
                    filter: 'drop-shadow(0 0 45px #2beeee)'
                  }}>
                    <Box component="span" sx={{ mr: 1 }}>Taranıyor</Box>
                    <Box component="span" sx={{ display: 'inline-flex', overflow: 'hidden', filter: 'drop-shadow(0 0 45px #2beeee)', animation: `${animationDot} 1s steps(6) infinite` }}>......</Box>
                  </Box>
                </>
              )}
            </Box>
          )}

          {isOcrLoading && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <CircularProgress size={20} />
              <Typography variant="body2">Görsel taranıyor, lütfen bekleyin...</Typography>
            </Box>
          )}

          {!isOcrLoading && ocrEdit && (
            <Stack spacing={2}>
              <TextField size="small" label="Ad/Ünvan" name="companyName" value={ocrEdit.companyName || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="Bölge" name="region" value={ocrEdit.region || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="Şehir" name="city" value={ocrEdit.city || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="İlçe" name="district" value={ocrEdit.district || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="Adres" name="address" value={ocrEdit.address || ''} onChange={handleOcrEditChange} fullWidth multiline minRows={2} />
              <TextField size="small" label="Tel" name="phone" value={ocrEdit.phone || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="Mail" name="email" value={ocrEdit.email || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="Vergi Dairesi (Metin)" name="taxOffice" value={ocrEdit.taxOffice || ''} onChange={handleOcrEditChange} fullWidth />
              <Autocomplete
                size="small"
                fullWidth
                value={(taxOfficesDataFromHook || []).find((o: any) => String(o.taxOfficeCode) === ocrTaxOfficeCode) || null}
                onChange={(_, newVal: any) => {
                  const code = newVal ? String(newVal.taxOfficeCode) : '';
                  setOcrTaxOfficeCode(code);
                  if (newVal) {
                    setOcrEdit(prev => prev ? ({ ...prev, taxOffice: String(newVal.taxOfficeDescription || '') }) as OcrExtractResult : prev);
                  }
                }}
                options={(taxOfficesDataFromHook || []) as any[]}
                getOptionLabel={(opt: any) => `${opt.taxOfficeCode} — ${opt.taxOfficeDescription}`}
                isOptionEqualToValue={(opt: any, val: any) => String(opt.taxOfficeCode) === String(val.taxOfficeCode)}
                loading={Boolean(isLoadingTaxOfficesHook)}
                loadingText="Yükleniyor..."
                noOptionsText="Kayıt bulunamadı"
                disablePortal
                openOnFocus
                autoHighlight
                blurOnSelect
                filterOptions={(options: any[], state) => {
                  const input = normalizeTrUpper(state.inputValue || '');
                  if (!input) return options;
                  return options.filter((o: any) => {
                    const code = normalizeTrUpper(String(o.taxOfficeCode || ''));
                    const desc = normalizeTrUpper(String(o.taxOfficeDescription || ''));
                    return code.includes(input) || desc.includes(input) || input.includes(desc);
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Vergi Dairesi (Kod Seçimi)" placeholder="Ara ve seç" />
                )}
                clearOnEscape
              />
              <TextField size="small" label="Vergi No" name="taxNumber" value={ocrEdit.taxNumber || ''} onChange={handleOcrEditChange} fullWidth />
              <TextField size="small" label="TCKN" name="identityNum" value={ocrEdit.identityNum || ''} onChange={handleOcrEditChange} fullWidth />
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseOcrModal}>Vazgeç</Button>
          <Button variant="contained" color="primary" onClick={applyOcrToForm} startIcon={<CheckCircleIcon />} disabled={!ocrEdit}>Uygula</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {showConfetti && (
        <ReactConfetti
          width={windowDimensions.width}
          height={windowDimensions.height}
          recycle={false}
          numberOfPieces={500}
          gravity={0.2}
          onConfettiComplete={() => setShowConfetti(false)}
        />
      )}
      
      {/* Müşteri Özellikleri Modalı */}
      <CustomerPropertiesModal
        open={isCustomerPropertiesModalOpen}
        onClose={() => setIsCustomerPropertiesModalOpen(false)}
        customerCode="temp" // Geçici bir değer, müşteri henüz oluşturulmadı
        regionCode={(formData.region || (formData as any).stateCode) as string}
        autoSaveOnReady
        autoSaveDelayMs={2000}
        onSave={(payload) => {
          console.log('Modal payload:', payload);
          // 1) Ortak müşteri özelliklerini kaydet (typeCode -> value), key'leri number'a çevir
          const cp: Record<number, string> = {};
          Object.entries(payload.CustomerProperties || {}).forEach(([k, v]) => {
            const nk = parseInt(k, 10);
            if (!Number.isNaN(nk)) cp[nk] = String(v ?? '');
          });
          setSelectedCustomerProperties(cp);

          // 2) Per-DB seçimlerini sayfa state'ine taşı
          const get = (obj: Record<string, string> | undefined, key: string) => (obj && obj[key]) || '';
          const getProp = (obj: Record<string, Record<string, string>> | undefined, db: string, type: string) => (obj && obj[db] && obj[db][type]) || '';
          const stPrice = get(payload.PerDbWholesalePriceGroupCode, 'V3_StDeri');
          const stDisc = get(payload.PerDbDiscountGroupCode, 'V3_StDeri');
          const stInv  = getProp(payload.PerDbCustomerProperties, 'V3_StDeri', '1');
          const stSp   = get(payload.PerDbSalespersonCodes, 'V3_StDeri');
          const scPrice = get(payload.PerDbWholesalePriceGroupCode, 'V3_SerkanCanta');
          const scDisc  = get(payload.PerDbDiscountGroupCode, 'V3_SerkanCanta');
          const scInv   = getProp(payload.PerDbCustomerProperties, 'V3_SerkanCanta', '1');
          const scSp    = get(payload.PerDbSalespersonCodes, 'V3_SerkanCanta');

          setPerDbSelections({
            stDeri: { priceGroup: stPrice, discountGroup: stDisc, invoiceType: stInv, salesperson: stSp },
            serkanCanta: { priceGroup: scPrice, discountGroup: scDisc, invoiceType: scInv, salesperson: scSp },
          });
        }}
        onLookupSelectionChange={(priceGroupCode: string, discountGroupCode: string) => {
          console.log('Modal -> onLookupSelectionChange çağrıldı:', { priceGroupCode, discountGroupCode });
          // Modal zaten veritabanına göre default seçimi yapıyor; burada ekstra fallback uygulamayalım
          setSelectedWholesalePriceGroupCode(priceGroupCode || '');
          setSelectedDiscountGroupCode(discountGroupCode || '');
        }}
        onSelectionChangePerDb={(data) => {
          setPerDbSelections({
            stDeri: {
              priceGroup: data.stDeri.priceGroup || '',
              discountGroup: data.stDeri.discountGroup || '',
              invoiceType: data.stDeri.invoiceType || '',
              salesperson: data.stDeri.salesperson || ''
            },
            serkanCanta: {
              priceGroup: data.serkanCanta.priceGroup || '',
              discountGroup: data.serkanCanta.discountGroup || '',
              invoiceType: data.serkanCanta.invoiceType || '',
              salesperson: data.serkanCanta.salesperson || ''
            }
          });
        }}
      />
      {/* Alt Müşteriler Modalı */}
      <SubCustomersModal
        open={uiShowSubCustomerButton && isSubCustomersModalOpen}
        onClose={() => setIsSubCustomersModalOpen(false)}
        value={subCustomers}
        onChange={setSubCustomers}
        currencies={Array.isArray(currenciesDataFromHook) ? currenciesDataFromHook : []}
        // Lookup listeleri
        taxOffices={(taxOfficesDataFromHook || []).map((o: any) => ({ code: o.taxOfficeCode, name: o.taxOfficeDescription }))}
        taxOfficesRaw={taxOfficesDataFromHook as any}
        // Toptan fiyat ve iskonto grupları: Select seçenekleri
        priceGroups={(priceGroupsLookup || []).map(pg => ({ code: pg.priceGroupCode, name: pg.priceGroupDescription }))}
        discountGroups={(discountGroupsLookup || []).map(dg => ({ code: dg.discountGroupCode, name: dg.discountGroupDescription }))}
        // Ana formdan seçili değerler (modalda kilitli olarak görünsün)
        selectedCurrencyCode={formData.exchangeTypeCode}
        selectedTaxOfficeCode={formData.taxOffice}
        selectedPriceGroupCode={selectedWholesalePriceGroupCode}
        selectedDiscountGroupCode={selectedDiscountGroupCode}
      />
      </Container>
    </Box>
  );
};

export default CustomerCreate;
